import * as z from 'zod';

export const SearchRsvpsRequest = z.object({
  search: z
    .object({
      filter: z
        .object({
          _id: z
            .object({
              $eq: z.string(),
              $exists: z.boolean(),
              $gt: z.string(),
              $gte: z.string(),
              $hasAll: z.array(z.string()),
              $hasSome: z.array(z.string()),
              $in: z.array(z.string()),
              $lt: z.string(),
              $lte: z.string(),
              $ne: z.string(),
              $nin: z.array(z.string()),
              $startsWith: z.string(),
            })
            .partial()
            .strict()
            .optional(),
          eventId: z
            .object({
              $eq: z.string(),
              $exists: z.boolean(),
              $gt: z.string(),
              $gte: z.string(),
              $hasAll: z.array(z.string()),
              $hasSome: z.array(z.string()),
              $in: z.array(z.string()),
              $lt: z.string(),
              $lte: z.string(),
              $ne: z.string(),
              $nin: z.array(z.string()),
              $startsWith: z.string(),
            })
            .partial()
            .strict()
            .optional(),
          _createdDate: z
            .object({
              $eq: z.string(),
              $exists: z.boolean(),
              $gt: z.string(),
              $gte: z.string(),
              $hasAll: z.array(z.string()),
              $hasSome: z.array(z.string()),
              $in: z.array(z.string()),
              $lt: z.string(),
              $lte: z.string(),
              $ne: z.string(),
              $nin: z.array(z.string()),
              $startsWith: z.string(),
            })
            .partial()
            .strict()
            .optional(),
          _updatedDate: z
            .object({
              $eq: z.string(),
              $exists: z.boolean(),
              $gt: z.string(),
              $gte: z.string(),
              $hasAll: z.array(z.string()),
              $hasSome: z.array(z.string()),
              $in: z.array(z.string()),
              $lt: z.string(),
              $lte: z.string(),
              $ne: z.string(),
              $nin: z.array(z.string()),
              $startsWith: z.string(),
            })
            .partial()
            .strict()
            .optional(),
          memberId: z
            .object({
              $eq: z.string(),
              $exists: z.boolean(),
              $gt: z.string(),
              $gte: z.string(),
              $hasAll: z.array(z.string()),
              $hasSome: z.array(z.string()),
              $in: z.array(z.string()),
              $lt: z.string(),
              $lte: z.string(),
              $ne: z.string(),
              $nin: z.array(z.string()),
              $startsWith: z.string(),
            })
            .partial()
            .strict()
            .optional(),
          contactId: z
            .object({
              $eq: z.string(),
              $exists: z.boolean(),
              $gt: z.string(),
              $gte: z.string(),
              $hasAll: z.array(z.string()),
              $hasSome: z.array(z.string()),
              $in: z.array(z.string()),
              $lt: z.string(),
              $lte: z.string(),
              $ne: z.string(),
              $nin: z.array(z.string()),
              $startsWith: z.string(),
            })
            .partial()
            .strict()
            .optional(),
          firstName: z
            .object({
              $eq: z.string(),
              $exists: z.boolean(),
              $gt: z.string(),
              $gte: z.string(),
              $hasAll: z.array(z.string()),
              $hasSome: z.array(z.string()),
              $in: z.array(z.string()),
              $lt: z.string(),
              $lte: z.string(),
              $ne: z.string(),
              $nin: z.array(z.string()),
              $startsWith: z.string(),
            })
            .partial()
            .strict()
            .optional(),
          lastName: z
            .object({
              $eq: z.string(),
              $exists: z.boolean(),
              $gt: z.string(),
              $gte: z.string(),
              $hasAll: z.array(z.string()),
              $hasSome: z.array(z.string()),
              $in: z.array(z.string()),
              $lt: z.string(),
              $lte: z.string(),
              $ne: z.string(),
              $nin: z.array(z.string()),
              $startsWith: z.string(),
            })
            .partial()
            .strict()
            .optional(),
          email: z
            .object({
              $eq: z.string(),
              $exists: z.boolean(),
              $gt: z.string(),
              $gte: z.string(),
              $hasAll: z.array(z.string()),
              $hasSome: z.array(z.string()),
              $in: z.array(z.string()),
              $lt: z.string(),
              $lte: z.string(),
              $ne: z.string(),
              $nin: z.array(z.string()),
              $startsWith: z.string(),
            })
            .partial()
            .strict()
            .optional(),
          status: z
            .object({
              $eq: z.string(),
              $exists: z.boolean(),
              $gt: z.string(),
              $gte: z.string(),
              $hasAll: z.array(z.string()),
              $hasSome: z.array(z.string()),
              $in: z.array(z.string()),
              $lt: z.string(),
              $lte: z.string(),
              $ne: z.string(),
              $nin: z.array(z.string()),
              $startsWith: z.string(),
            })
            .partial()
            .strict()
            .optional(),
          totalGuests: z
            .object({
              $eq: z.number(),
              $exists: z.boolean(),
              $gt: z.number(),
              $gte: z.number(),
              $hasAll: z.array(z.number()),
              $hasSome: z.array(z.number()),
              $in: z.array(z.number()),
              $lt: z.number(),
              $lte: z.number(),
              $ne: z.number(),
              $nin: z.array(z.number()),
              $startsWith: z.string(),
            })
            .partial()
            .strict()
            .optional(),
          checkedInGuestCount: z
            .object({
              $eq: z.number(),
              $exists: z.boolean(),
              $gt: z.number(),
              $gte: z.number(),
              $hasAll: z.array(z.number()),
              $hasSome: z.array(z.number()),
              $in: z.array(z.number()),
              $lt: z.number(),
              $lte: z.number(),
              $ne: z.number(),
              $nin: z.array(z.number()),
              $startsWith: z.string(),
            })
            .partial()
            .strict()
            .optional(),
          fullyCheckedIn: z
            .object({
              $eq: z.boolean(),
              $exists: z.boolean(),
              $gt: z.boolean(),
              $gte: z.boolean(),
              $hasAll: z.array(z.boolean()),
              $hasSome: z.array(z.boolean()),
              $in: z.array(z.boolean()),
              $lt: z.boolean(),
              $lte: z.boolean(),
              $ne: z.boolean(),
              $nin: z.array(z.boolean()),
              $startsWith: z.string(),
            })
            .partial()
            .strict()
            .optional(),
          anonymized: z
            .object({
              $eq: z.boolean(),
              $exists: z.boolean(),
              $gt: z.boolean(),
              $gte: z.boolean(),
              $hasAll: z.array(z.boolean()),
              $hasSome: z.array(z.boolean()),
              $in: z.array(z.boolean()),
              $lt: z.boolean(),
              $lte: z.boolean(),
              $ne: z.boolean(),
              $nin: z.array(z.boolean()),
              $startsWith: z.string(),
            })
            .partial()
            .strict()
            .optional(),
          $and: z.array(z.any()).optional(),
          $or: z.array(z.any()).optional(),
          $not: z.any().optional(),
        })
        .strict()
        .optional(),
      sort: z
        .array(
          z.object({
            fieldName: z
              .enum([
                '_id',
                'eventId',
                '_createdDate',
                '_updatedDate',
                'memberId',
                'contactId',
                'firstName',
                'lastName',
                'email',
                'status',
                'totalGuests',
                'checkedInGuestCount',
                'fullyCheckedIn',
                'anonymized',
              ])
              .optional(),
            order: z.enum(['ASC', 'DESC']).optional(),
          })
        )
        .optional(),
    })
    .catchall(z.any())
    .describe(
      'Search options. See [API Query Language](https://dev.wix.com/docs/rest/articles/get-started/api-query-language) for more details.'
    ),
  options: z
    .object({
      fields: z
        .array(z.enum(['DETAILS', 'FORM', 'CONTACT_DETAILS']))
        .max(3)
        .optional(),
    })
    .optional(),
});
export const SearchRsvpsResponse = z.object({
  rsvps: z
    .array(
      z.object({
        _id: z
          .string()
          .describe('ID of the RSVP.')
          .regex(
            /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
            'Must be a valid GUID'
          )
          .optional()
          .nullable(),
        revision: z
          .string()
          .regex(/^-?\d+$/, 'Must be a valid Int64 string')
          .describe(
            'Revision number, which increments by 1 each time the RSVP is updated. To prevent conflicting changes, the existing `revision` must be used when updating the RSVP.'
          )
          .optional()
          .nullable(),
        eventId: z
          .string()
          .describe('Event ID to which the RSVP belongs.')
          .regex(
            /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
            'Must be a valid GUID'
          )
          .optional()
          .nullable(),
        _createdDate: z
          .date()
          .describe('Date and time the RSVP was created.')
          .optional()
          .nullable(),
        _updatedDate: z
          .date()
          .describe('Date and time the RSVP was updated.')
          .optional()
          .nullable(),
        memberId: z
          .string()
          .describe('Site member ID.')
          .regex(
            /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
            'Must be a valid GUID'
          )
          .optional()
          .nullable(),
        contactId: z
          .string()
          .describe(
            'Contact ID of a guest who filled in the RSVP form. See the Contacts API for more details.'
          )
          .regex(
            /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
            'Must be a valid GUID'
          )
          .optional()
          .nullable(),
        firstName: z
          .string()
          .describe('First name of a guest who filled in the RSVP form.')
          .min(1)
          .max(50)
          .optional()
          .nullable(),
        lastName: z
          .string()
          .describe('Last name of a guest who filled in the RSVP form.')
          .min(1)
          .max(50)
          .optional()
          .nullable(),
        email: z
          .string()
          .describe('Email of a guest who filled in the RSVP form.')
          .email()
          .min(4)
          .max(255)
          .optional()
          .nullable(),
        form: z
          .object({
            inputValues: z
              .array(
                z.object({
                  inputName: z
                    .string()
                    .describe('Form field input name.')
                    .max(100)
                    .optional(),
                  value: z
                    .string()
                    .describe('Form field value.')
                    .max(5000)
                    .optional(),
                  values: z.array(z.string()).max(100).optional(),
                })
              )
              .max(200)
              .optional(),
          })
          .describe('Event registration form.')
          .optional(),
        status: z
          .enum(['YES', 'NO', 'WAITLIST'])
          .describe('RSVP response status.')
          .optional(),
        totalGuests: z
          .number()
          .int()
          .describe('Total number of guests per 1 RSVP.')
          .optional()
          .nullable(),
        guestList: z
          .object({
            guests: z
              .array(
                z.object({
                  index: z
                    .number()
                    .int()
                    .describe('Index of each guest in the array.')
                    .optional()
                    .nullable(),
                  fullName: z
                    .string()
                    .describe('Full name.')
                    .max(101)
                    .optional()
                    .nullable(),
                  checkInDetails: z
                    .object({
                      checkedIn: z
                        .boolean()
                        .describe('Whether the guest has checked in.')
                        .optional()
                        .nullable(),
                      checkInDate: z
                        .date()
                        .describe('Date and time the guest checked in.')
                        .optional()
                        .nullable(),
                      checkInCanceledDate: z
                        .date()
                        .describe('Date and time the guest cancelled check-in.')
                        .optional()
                        .nullable(),
                      checkedInBy: z
                        .string()
                        .describe('Id of the user who last performed check-in')
                        .regex(
                          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                          'Must be a valid GUID'
                        )
                        .optional()
                        .nullable(),
                      checkInCanceledBy: z
                        .string()
                        .describe('Id of the user who last canceled check-in')
                        .regex(
                          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                          'Must be a valid GUID'
                        )
                        .optional()
                        .nullable(),
                      checkedInByStaffMember: z
                        .string()
                        .describe(
                          'Id of the Staff Member who last performed check-in'
                        )
                        .regex(
                          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                          'Must be a valid GUID'
                        )
                        .optional()
                        .nullable(),
                      checkInCanceledByStaffMember: z
                        .string()
                        .describe(
                          'Id of theStaff Member who last canceled check-in'
                        )
                        .regex(
                          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                          'Must be a valid GUID'
                        )
                        .optional()
                        .nullable(),
                    })
                    .describe('Check-in details.')
                    .optional(),
                  guestId: z
                    .number()
                    .int()
                    .describe('Guest ID.')
                    .min(1)
                    .optional()
                    .nullable(),
                })
              )
              .max(11)
              .optional(),
          })
          .describe('Guest list.')
          .optional(),
        language: z
          .string()
          .describe(
            '2-letter language code in the [ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes) format.'
          )
          .optional()
          .nullable(),
        locale: z
          .string()
          .describe(
            'Locale in the [IETF BCP 47](https://en.wikipedia.org/wiki/IETF_language_tag) format.'
          )
          .optional()
          .nullable(),
        fullyCheckedIn: z
          .boolean()
          .describe('Whether all guests are checked in.')
          .optional()
          .nullable(),
        checkedInGuestCount: z
          .number()
          .int()
          .describe('Number of checked in guests.')
          .optional()
          .nullable(),
        additionalGuestDetails: z
          .object({
            guestCount: z
              .number()
              .int()
              .describe('Number of additional guests.')
              .min(0)
              .max(10)
              .optional()
              .nullable(),
            guestNames: z.array(z.string()).max(10).optional(),
          })
          .describe('Additional guest details.')
          .optional(),
        disableNotifications: z
          .boolean()
          .describe('Whether notifications are disabled.')
          .optional()
          .nullable(),
        onlineConferencingLogin: z
          .object({
            link: z
              .string()
              .describe('Link URL to the online conference.')
              .url()
              .optional(),
            password: z
              .string()
              .describe('Password for the online conference.')
              .optional()
              .nullable(),
          })
          .describe(
            'Guest login details for accessing the online conference event.'
          )
          .optional(),
        anonymized: z
          .boolean()
          .describe('Whether an RSVP is anonymized.')
          .optional()
          .nullable(),
        marketingConsent: z
          .boolean()
          .describe('Whether a guest agreed to marketing.')
          .optional()
          .nullable(),
        extendedFields: z
          .object({
            namespaces: z
              .record(z.string(), z.record(z.string(), z.any()))
              .describe(
                'Extended field data. Each key corresponds to the namespace of the app that created the extended fields.\nThe value of each key is structured according to the schema defined when the extended fields were configured.\n\nYou can only access fields for which you have the appropriate permissions.\n\nLearn more about [extended fields](https://dev.wix.com/docs/rest/articles/getting-started/extended-fields).'
              )
              .optional(),
          })
          .describe(
            "Custom field data for the RSVP object.\n\n**Note:** You must configure extended fields using schema plugin extensions in your app's dashboard before you can access the extended fields with API calls."
          )
          .optional(),
      })
    )
    .optional(),
  pagingMetadata: z
    .object({
      count: z
        .number()
        .int()
        .describe('Number of items returned in the response.')
        .optional()
        .nullable(),
      cursors: z
        .object({
          next: z
            .string()
            .describe(
              'Cursor string pointing to the next page in the list of results.'
            )
            .max(16000)
            .optional()
            .nullable(),
          prev: z
            .string()
            .describe(
              'Cursor pointing to the previous page in the list of results.'
            )
            .max(16000)
            .optional()
            .nullable(),
        })
        .describe(
          'Cursor strings that point to the next page, previous page, or both.'
        )
        .optional(),
      hasNext: z
        .boolean()
        .describe(
          'Whether there are more pages to retrieve following the current page.\n\n+ `true`: Another page of results can be retrieved.\n+ `false`: This is the last page.'
        )
        .optional()
        .nullable(),
    })
    .describe('Metadata for the paginated results.')
    .optional(),
  aggregationData: z
    .object({
      results: z
        .array(
          z.intersection(
            z.object({
              name: z
                .string()
                .describe('Aggregation name displayed in the return.')
                .max(100)
                .optional(),
              type: z
                .enum(['VALUE', 'RANGE', 'SCALAR', 'DATE_HISTOGRAM', 'NESTED'])
                .describe('Type of aggregation that was performed.')
                .optional(),
              fieldPath: z
                .string()
                .describe('Field which the data was aggregated by.')
                .max(200)
                .optional(),
            }),
            z.xor([
              z.object({
                values: z.never().optional(),
                ranges: z.never().optional(),
                scalar: z.never().optional(),
                groupedByValue: z.never().optional(),
                dateHistogram: z.never().optional(),
                nested: z.never().optional(),
              }),
              z.object({
                ranges: z.never().optional(),
                scalar: z.never().optional(),
                groupedByValue: z.never().optional(),
                dateHistogram: z.never().optional(),
                nested: z.never().optional(),
                values: z
                  .object({
                    results: z
                      .array(
                        z.object({
                          value: z
                            .string()
                            .describe('Value of the field.')
                            .max(100)
                            .optional(),
                          count: z
                            .number()
                            .int()
                            .describe(
                              'Total number of entities with this value.'
                            )
                            .optional(),
                        })
                      )
                      .max(250)
                      .optional(),
                  })
                  .describe('Value aggregation results.'),
              }),
              z.object({
                values: z.never().optional(),
                scalar: z.never().optional(),
                groupedByValue: z.never().optional(),
                dateHistogram: z.never().optional(),
                nested: z.never().optional(),
                ranges: z
                  .object({
                    results: z
                      .array(
                        z.object({
                          from: z
                            .number()
                            .describe('Inclusive lower bound of the range.')
                            .optional()
                            .nullable(),
                          to: z
                            .number()
                            .describe('Exclusive upper bound of the range.')
                            .optional()
                            .nullable(),
                          count: z
                            .number()
                            .int()
                            .describe('Count of entities in this range.')
                            .optional(),
                        })
                      )
                      .max(50)
                      .optional(),
                  })
                  .describe('Range aggregation results.'),
              }),
              z.object({
                values: z.never().optional(),
                ranges: z.never().optional(),
                groupedByValue: z.never().optional(),
                dateHistogram: z.never().optional(),
                nested: z.never().optional(),
                scalar: z
                  .object({
                    type: z
                      .enum(['COUNT_DISTINCT', 'MIN', 'MAX'])
                      .describe('Type of scalar aggregation.')
                      .optional(),
                    value: z
                      .number()
                      .describe('Value of the scalar aggregation.')
                      .optional(),
                  })
                  .describe('Scalar aggregation results.'),
              }),
              z.object({
                values: z.never().optional(),
                ranges: z.never().optional(),
                scalar: z.never().optional(),
                dateHistogram: z.never().optional(),
                nested: z.never().optional(),
                groupedByValue: z
                  .object({
                    results: z
                      .array(
                        z.object({
                          value: z
                            .string()
                            .describe('Value of the field.')
                            .max(1000)
                            .optional(),
                          nestedResults: z
                            .intersection(
                              z.object({
                                name: z
                                  .string()
                                  .describe(
                                    'Unique, caller-defined aggregation name, identifiable by the requested aggregation `name`.'
                                  )
                                  .max(100)
                                  .optional(),
                                type: z
                                  .enum([
                                    'VALUE',
                                    'RANGE',
                                    'SCALAR',
                                    'DATE_HISTOGRAM',
                                    'NESTED',
                                  ])
                                  .describe('Aggregation type.')
                                  .optional(),
                                fieldPath: z
                                  .string()
                                  .describe(
                                    'Field which the data was aggregated by.'
                                  )
                                  .max(200)
                                  .optional(),
                              }),
                              z.xor([
                                z.object({
                                  values: z.never().optional(),
                                  ranges: z.never().optional(),
                                  scalar: z.never().optional(),
                                }),
                                z.object({
                                  ranges: z.never().optional(),
                                  scalar: z.never().optional(),
                                  values: z
                                    .object({
                                      results: z
                                        .array(
                                          z.object({
                                            value: z
                                              .string()
                                              .describe('Value of the field.')
                                              .max(100)
                                              .optional(),
                                            count: z
                                              .number()
                                              .int()
                                              .describe(
                                                'Total number of entities with this value.'
                                              )
                                              .optional(),
                                          })
                                        )
                                        .max(250)
                                        .optional(),
                                    })
                                    .describe('Value aggregation results.'),
                                }),
                                z.object({
                                  values: z.never().optional(),
                                  scalar: z.never().optional(),
                                  ranges: z
                                    .object({
                                      results: z
                                        .array(
                                          z.object({
                                            from: z
                                              .number()
                                              .describe(
                                                'Inclusive lower bound of the range.'
                                              )
                                              .optional()
                                              .nullable(),
                                            to: z
                                              .number()
                                              .describe(
                                                'Exclusive upper bound of the range.'
                                              )
                                              .optional()
                                              .nullable(),
                                            count: z
                                              .number()
                                              .int()
                                              .describe(
                                                'Count of entities in this range.'
                                              )
                                              .optional(),
                                          })
                                        )
                                        .max(50)
                                        .optional(),
                                    })
                                    .describe('Range aggregation results.'),
                                }),
                                z.object({
                                  values: z.never().optional(),
                                  ranges: z.never().optional(),
                                  scalar: z
                                    .object({
                                      type: z
                                        .enum(['COUNT_DISTINCT', 'MIN', 'MAX'])
                                        .describe('Type of scalar aggregation.')
                                        .optional(),
                                      value: z
                                        .number()
                                        .describe(
                                          'Value of the scalar aggregation.'
                                        )
                                        .optional(),
                                    })
                                    .describe('Scalar aggregation results.'),
                                }),
                              ])
                            )
                            .describe('Nested aggregations.')
                            .optional(),
                        })
                      )
                      .max(1000)
                      .optional(),
                  })
                  .describe('Group by value aggregation results.'),
              }),
              z.object({
                values: z.never().optional(),
                ranges: z.never().optional(),
                scalar: z.never().optional(),
                groupedByValue: z.never().optional(),
                nested: z.never().optional(),
                dateHistogram: z
                  .object({
                    results: z
                      .array(
                        z.object({
                          value: z
                            .string()
                            .describe(
                              'Date in [ISO 8601](https://en.wikipedia.org/wiki/ISO_8601) format.'
                            )
                            .max(100)
                            .optional(),
                          count: z
                            .number()
                            .int()
                            .describe('Total number of entities in the bucket.')
                            .optional(),
                        })
                      )
                      .max(200)
                      .optional(),
                  })
                  .describe('Date histogram aggregation results.'),
              }),
              z.object({
                values: z.never().optional(),
                ranges: z.never().optional(),
                scalar: z.never().optional(),
                groupedByValue: z.never().optional(),
                dateHistogram: z.never().optional(),
                nested: z
                  .object({
                    results: z
                      .array(
                        z.object({
                          results: z
                            .record(
                              z.string(),
                              z.intersection(
                                z.object({}),
                                z.xor([
                                  z.object({
                                    value: z.never().optional(),
                                    range: z.never().optional(),
                                    scalar: z.never().optional(),
                                    dateHistogram: z.never().optional(),
                                  }),
                                  z.object({
                                    range: z.never().optional(),
                                    scalar: z.never().optional(),
                                    dateHistogram: z.never().optional(),
                                    value: z
                                      .object({
                                        value: z
                                          .string()
                                          .describe('Value of the field.')
                                          .max(1000)
                                          .optional(),
                                        count: z
                                          .number()
                                          .int()
                                          .describe(
                                            'Total number of entities with this value.'
                                          )
                                          .optional()
                                          .nullable(),
                                      })
                                      .describe('Value aggregation result.'),
                                  }),
                                  z.object({
                                    value: z.never().optional(),
                                    scalar: z.never().optional(),
                                    dateHistogram: z.never().optional(),
                                    range: z
                                      .object({
                                        from: z
                                          .number()
                                          .describe(
                                            'Inclusive lower bound of the range.'
                                          )
                                          .optional()
                                          .nullable(),
                                        to: z
                                          .number()
                                          .describe(
                                            'Exclusive upper bound of the range.'
                                          )
                                          .optional()
                                          .nullable(),
                                        count: z
                                          .number()
                                          .int()
                                          .describe(
                                            'Total number of entities in this range.'
                                          )
                                          .optional()
                                          .nullable(),
                                      })
                                      .describe('Range aggregation result.'),
                                  }),
                                  z.object({
                                    value: z.never().optional(),
                                    range: z.never().optional(),
                                    dateHistogram: z.never().optional(),
                                    scalar: z
                                      .object({
                                        value: z
                                          .number()
                                          .describe(
                                            'Value of the scalar aggregation.'
                                          )
                                          .optional(),
                                      })
                                      .describe('Scalar aggregation result.'),
                                  }),
                                  z.object({
                                    value: z.never().optional(),
                                    range: z.never().optional(),
                                    scalar: z.never().optional(),
                                    dateHistogram: z
                                      .object({
                                        value: z
                                          .string()
                                          .describe('Value of the field.')
                                          .max(1000)
                                          .optional(),
                                        count: z
                                          .number()
                                          .int()
                                          .describe(
                                            'Total number of entities with this value.'
                                          )
                                          .optional()
                                          .nullable(),
                                      })
                                      .describe(
                                        'Date histogram aggregation result.'
                                      ),
                                  }),
                                ])
                              )
                            )
                            .describe('List of nested aggregations.')
                            .optional(),
                        })
                      )
                      .max(1000)
                      .optional(),
                  })
                  .describe('Nested aggregation results.'),
              }),
            ])
          )
        )
        .max(10000)
        .optional(),
    })
    .describe('Aggregation data.')
    .optional(),
});
export const QueryRsvpsRequest = z.object({
  query: z
    .object({
      filter: z
        .object({
          _id: z
            .object({
              $eq: z.string(),
              $exists: z.boolean(),
              $in: z.array(z.string()),
              $ne: z.string(),
              $nin: z.array(z.string()),
            })
            .partial()
            .strict()
            .optional(),
          eventId: z
            .object({
              $eq: z.string(),
              $exists: z.boolean(),
              $in: z.array(z.string()),
              $ne: z.string(),
              $nin: z.array(z.string()),
            })
            .partial()
            .strict()
            .optional(),
          memberId: z
            .object({
              $eq: z.string(),
              $exists: z.boolean(),
              $in: z.array(z.string()),
              $ne: z.string(),
              $nin: z.array(z.string()),
            })
            .partial()
            .strict()
            .optional(),
          contactId: z
            .object({
              $eq: z.string(),
              $exists: z.boolean(),
              $in: z.array(z.string()),
              $ne: z.string(),
              $nin: z.array(z.string()),
            })
            .partial()
            .strict()
            .optional(),
          status: z
            .object({
              $eq: z.string(),
              $in: z.array(z.string()),
              $ne: z.string(),
              $nin: z.array(z.string()),
            })
            .partial()
            .strict()
            .optional(),
          fullyCheckedIn: z
            .object({
              $eq: z.boolean(),
              $in: z.array(z.boolean()),
              $ne: z.boolean(),
              $nin: z.array(z.boolean()),
            })
            .partial()
            .strict()
            .optional(),
          _updatedDate: z
            .object({
              $eq: z.string(),
              $gt: z.string(),
              $gte: z.string(),
              $in: z.array(z.string()),
              $lt: z.string(),
              $lte: z.string(),
              $ne: z.string(),
              $nin: z.array(z.string()),
            })
            .partial()
            .strict()
            .optional(),
          _createdDate: z
            .object({
              $eq: z.string(),
              $gt: z.string(),
              $gte: z.string(),
              $in: z.array(z.string()),
              $lt: z.string(),
              $lte: z.string(),
              $ne: z.string(),
              $nin: z.array(z.string()),
            })
            .partial()
            .strict()
            .optional(),
          $and: z.array(z.any()).optional(),
          $or: z.array(z.any()).optional(),
          $not: z.any().optional(),
        })
        .strict()
        .optional(),
      sort: z
        .array(
          z.object({
            fieldName: z
              .enum([
                'status',
                'fullyCheckedIn',
                '_updatedDate',
                '_createdDate',
              ])
              .optional(),
            order: z.enum(['ASC', 'DESC']).optional(),
          })
        )
        .optional(),
    })
    .catchall(z.any())
    .describe(
      'Query options. See [API Query Language](https://dev.wix.com/docs/rest/articles/get-started/api-query-language) for more details.'
    ),
  options: z
    .object({
      fields: z
        .array(z.enum(['DETAILS', 'FORM', 'CONTACT_DETAILS']))
        .max(3)
        .optional(),
    })
    .optional(),
});
export const QueryRsvpsResponse = z.object({
  rsvps: z
    .array(
      z.object({
        _id: z
          .string()
          .describe('ID of the RSVP.')
          .regex(
            /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
            'Must be a valid GUID'
          )
          .optional()
          .nullable(),
        revision: z
          .string()
          .regex(/^-?\d+$/, 'Must be a valid Int64 string')
          .describe(
            'Revision number, which increments by 1 each time the RSVP is updated. To prevent conflicting changes, the existing `revision` must be used when updating the RSVP.'
          )
          .optional()
          .nullable(),
        eventId: z
          .string()
          .describe('Event ID to which the RSVP belongs.')
          .regex(
            /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
            'Must be a valid GUID'
          )
          .optional()
          .nullable(),
        _createdDate: z
          .date()
          .describe('Date and time the RSVP was created.')
          .optional()
          .nullable(),
        _updatedDate: z
          .date()
          .describe('Date and time the RSVP was updated.')
          .optional()
          .nullable(),
        memberId: z
          .string()
          .describe('Site member ID.')
          .regex(
            /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
            'Must be a valid GUID'
          )
          .optional()
          .nullable(),
        contactId: z
          .string()
          .describe(
            'Contact ID of a guest who filled in the RSVP form. See the Contacts API for more details.'
          )
          .regex(
            /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
            'Must be a valid GUID'
          )
          .optional()
          .nullable(),
        firstName: z
          .string()
          .describe('First name of a guest who filled in the RSVP form.')
          .min(1)
          .max(50)
          .optional()
          .nullable(),
        lastName: z
          .string()
          .describe('Last name of a guest who filled in the RSVP form.')
          .min(1)
          .max(50)
          .optional()
          .nullable(),
        email: z
          .string()
          .describe('Email of a guest who filled in the RSVP form.')
          .email()
          .min(4)
          .max(255)
          .optional()
          .nullable(),
        form: z
          .object({
            inputValues: z
              .array(
                z.object({
                  inputName: z
                    .string()
                    .describe('Form field input name.')
                    .max(100)
                    .optional(),
                  value: z
                    .string()
                    .describe('Form field value.')
                    .max(5000)
                    .optional(),
                  values: z.array(z.string()).max(100).optional(),
                })
              )
              .max(200)
              .optional(),
          })
          .describe('Event registration form.')
          .optional(),
        status: z
          .enum(['YES', 'NO', 'WAITLIST'])
          .describe('RSVP response status.')
          .optional(),
        totalGuests: z
          .number()
          .int()
          .describe('Total number of guests per 1 RSVP.')
          .optional()
          .nullable(),
        guestList: z
          .object({
            guests: z
              .array(
                z.object({
                  index: z
                    .number()
                    .int()
                    .describe('Index of each guest in the array.')
                    .optional()
                    .nullable(),
                  fullName: z
                    .string()
                    .describe('Full name.')
                    .max(101)
                    .optional()
                    .nullable(),
                  checkInDetails: z
                    .object({
                      checkedIn: z
                        .boolean()
                        .describe('Whether the guest has checked in.')
                        .optional()
                        .nullable(),
                      checkInDate: z
                        .date()
                        .describe('Date and time the guest checked in.')
                        .optional()
                        .nullable(),
                      checkInCanceledDate: z
                        .date()
                        .describe('Date and time the guest cancelled check-in.')
                        .optional()
                        .nullable(),
                      checkedInBy: z
                        .string()
                        .describe('Id of the user who last performed check-in')
                        .regex(
                          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                          'Must be a valid GUID'
                        )
                        .optional()
                        .nullable(),
                      checkInCanceledBy: z
                        .string()
                        .describe('Id of the user who last canceled check-in')
                        .regex(
                          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                          'Must be a valid GUID'
                        )
                        .optional()
                        .nullable(),
                      checkedInByStaffMember: z
                        .string()
                        .describe(
                          'Id of the Staff Member who last performed check-in'
                        )
                        .regex(
                          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                          'Must be a valid GUID'
                        )
                        .optional()
                        .nullable(),
                      checkInCanceledByStaffMember: z
                        .string()
                        .describe(
                          'Id of theStaff Member who last canceled check-in'
                        )
                        .regex(
                          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                          'Must be a valid GUID'
                        )
                        .optional()
                        .nullable(),
                    })
                    .describe('Check-in details.')
                    .optional(),
                  guestId: z
                    .number()
                    .int()
                    .describe('Guest ID.')
                    .min(1)
                    .optional()
                    .nullable(),
                })
              )
              .max(11)
              .optional(),
          })
          .describe('Guest list.')
          .optional(),
        language: z
          .string()
          .describe(
            '2-letter language code in the [ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes) format.'
          )
          .optional()
          .nullable(),
        locale: z
          .string()
          .describe(
            'Locale in the [IETF BCP 47](https://en.wikipedia.org/wiki/IETF_language_tag) format.'
          )
          .optional()
          .nullable(),
        fullyCheckedIn: z
          .boolean()
          .describe('Whether all guests are checked in.')
          .optional()
          .nullable(),
        checkedInGuestCount: z
          .number()
          .int()
          .describe('Number of checked in guests.')
          .optional()
          .nullable(),
        additionalGuestDetails: z
          .object({
            guestCount: z
              .number()
              .int()
              .describe('Number of additional guests.')
              .min(0)
              .max(10)
              .optional()
              .nullable(),
            guestNames: z.array(z.string()).max(10).optional(),
          })
          .describe('Additional guest details.')
          .optional(),
        disableNotifications: z
          .boolean()
          .describe('Whether notifications are disabled.')
          .optional()
          .nullable(),
        onlineConferencingLogin: z
          .object({
            link: z
              .string()
              .describe('Link URL to the online conference.')
              .url()
              .optional(),
            password: z
              .string()
              .describe('Password for the online conference.')
              .optional()
              .nullable(),
          })
          .describe(
            'Guest login details for accessing the online conference event.'
          )
          .optional(),
        anonymized: z
          .boolean()
          .describe('Whether an RSVP is anonymized.')
          .optional()
          .nullable(),
        marketingConsent: z
          .boolean()
          .describe('Whether a guest agreed to marketing.')
          .optional()
          .nullable(),
        extendedFields: z
          .object({
            namespaces: z
              .record(z.string(), z.record(z.string(), z.any()))
              .describe(
                'Extended field data. Each key corresponds to the namespace of the app that created the extended fields.\nThe value of each key is structured according to the schema defined when the extended fields were configured.\n\nYou can only access fields for which you have the appropriate permissions.\n\nLearn more about [extended fields](https://dev.wix.com/docs/rest/articles/getting-started/extended-fields).'
              )
              .optional(),
          })
          .describe(
            "Custom field data for the RSVP object.\n\n**Note:** You must configure extended fields using schema plugin extensions in your app's dashboard before you can access the extended fields with API calls."
          )
          .optional(),
      })
    )
    .optional(),
  pagingMetadata: z
    .object({
      count: z
        .number()
        .int()
        .describe('Number of items returned in the response.')
        .optional()
        .nullable(),
      cursors: z
        .object({
          next: z
            .string()
            .describe(
              'Cursor string pointing to the next page in the list of results.'
            )
            .max(16000)
            .optional()
            .nullable(),
          prev: z
            .string()
            .describe(
              'Cursor pointing to the previous page in the list of results.'
            )
            .max(16000)
            .optional()
            .nullable(),
        })
        .describe(
          'Cursor strings that point to the next page, previous page, or both.'
        )
        .optional(),
      hasNext: z
        .boolean()
        .describe(
          'Whether there are more pages to retrieve following the current page.\n\n+ `true`: Another page of results can be retrieved.\n+ `false`: This is the last page.'
        )
        .optional()
        .nullable(),
    })
    .describe('Metadata for the paginated results.')
    .optional(),
});
export const CountRsvpsRequest = z.object({
  options: z
    .object({
      filter: z
        .record(z.string(), z.any())
        .describe(
          'Filter object in the following format:\n`"filter" : {\n"fieldName1": "value1",\n"fieldName2":{"$operator":"value2"}\n}`\nExample of operators: `$eq`, `$ne`, `$lt`, `$lte`, `$gt`, `$gte`, `$in`, `$hasSome`, `$hasAll`, `$startsWith`, `$contains`'
        )
        .optional()
        .nullable(),
      search: z
        .object({
          mode: z.enum(['OR', 'AND']).optional(),
          expression: z
            .string()
            .describe('Search term or expression.')
            .max(100)
            .optional()
            .nullable(),
          fields: z.array(z.string()).max(20).optional(),
          fuzzy: z
            .boolean()
            .describe(
              'Whether to enable the search function to use an algorithm to automatically find results that are close to the search expression, such as typos and declensions.'
            )
            .optional(),
        })
        .describe('Search details.')
        .optional(),
    })
    .optional(),
});
export const CountRsvpsResponse = z.object({
  count: z.number().int().describe('Number of RSVPs.').optional(),
});
export const GetRsvpRequest = z.object({
  rsvpId: z
    .string()
    .describe('ID of the RSVP to retrieve.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    ),
  options: z
    .object({
      fields: z
        .array(z.enum(['DETAILS', 'FORM', 'CONTACT_DETAILS']))
        .max(3)
        .optional(),
    })
    .optional(),
});
export const GetRsvpResponse = z.object({
  _id: z
    .string()
    .describe('ID of the RSVP.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    )
    .optional()
    .nullable(),
  revision: z
    .string()
    .regex(/^-?\d+$/, 'Must be a valid Int64 string')
    .describe(
      'Revision number, which increments by 1 each time the RSVP is updated. To prevent conflicting changes, the existing `revision` must be used when updating the RSVP.'
    )
    .optional()
    .nullable(),
  eventId: z
    .string()
    .describe('Event ID to which the RSVP belongs.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    )
    .optional()
    .nullable(),
  _createdDate: z
    .date()
    .describe('Date and time the RSVP was created.')
    .optional()
    .nullable(),
  _updatedDate: z
    .date()
    .describe('Date and time the RSVP was updated.')
    .optional()
    .nullable(),
  memberId: z
    .string()
    .describe('Site member ID.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    )
    .optional()
    .nullable(),
  contactId: z
    .string()
    .describe(
      'Contact ID of a guest who filled in the RSVP form. See the Contacts API for more details.'
    )
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    )
    .optional()
    .nullable(),
  firstName: z
    .string()
    .describe('First name of a guest who filled in the RSVP form.')
    .min(1)
    .max(50)
    .optional()
    .nullable(),
  lastName: z
    .string()
    .describe('Last name of a guest who filled in the RSVP form.')
    .min(1)
    .max(50)
    .optional()
    .nullable(),
  email: z
    .string()
    .describe('Email of a guest who filled in the RSVP form.')
    .email()
    .min(4)
    .max(255)
    .optional()
    .nullable(),
  form: z
    .object({
      inputValues: z
        .array(
          z.object({
            inputName: z
              .string()
              .describe('Form field input name.')
              .max(100)
              .optional(),
            value: z
              .string()
              .describe('Form field value.')
              .max(5000)
              .optional(),
            values: z.array(z.string()).max(100).optional(),
          })
        )
        .max(200)
        .optional(),
    })
    .describe('Event registration form.')
    .optional(),
  status: z
    .enum(['YES', 'NO', 'WAITLIST'])
    .describe('RSVP response status.')
    .optional(),
  totalGuests: z
    .number()
    .int()
    .describe('Total number of guests per 1 RSVP.')
    .optional()
    .nullable(),
  guestList: z
    .object({
      guests: z
        .array(
          z.object({
            index: z
              .number()
              .int()
              .describe('Index of each guest in the array.')
              .optional()
              .nullable(),
            fullName: z
              .string()
              .describe('Full name.')
              .max(101)
              .optional()
              .nullable(),
            checkInDetails: z
              .object({
                checkedIn: z
                  .boolean()
                  .describe('Whether the guest has checked in.')
                  .optional()
                  .nullable(),
                checkInDate: z
                  .date()
                  .describe('Date and time the guest checked in.')
                  .optional()
                  .nullable(),
                checkInCanceledDate: z
                  .date()
                  .describe('Date and time the guest cancelled check-in.')
                  .optional()
                  .nullable(),
                checkedInBy: z
                  .string()
                  .describe('Id of the user who last performed check-in')
                  .regex(
                    /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                    'Must be a valid GUID'
                  )
                  .optional()
                  .nullable(),
                checkInCanceledBy: z
                  .string()
                  .describe('Id of the user who last canceled check-in')
                  .regex(
                    /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                    'Must be a valid GUID'
                  )
                  .optional()
                  .nullable(),
                checkedInByStaffMember: z
                  .string()
                  .describe(
                    'Id of the Staff Member who last performed check-in'
                  )
                  .regex(
                    /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                    'Must be a valid GUID'
                  )
                  .optional()
                  .nullable(),
                checkInCanceledByStaffMember: z
                  .string()
                  .describe('Id of theStaff Member who last canceled check-in')
                  .regex(
                    /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                    'Must be a valid GUID'
                  )
                  .optional()
                  .nullable(),
              })
              .describe('Check-in details.')
              .optional(),
            guestId: z
              .number()
              .int()
              .describe('Guest ID.')
              .min(1)
              .optional()
              .nullable(),
          })
        )
        .max(11)
        .optional(),
    })
    .describe('Guest list.')
    .optional(),
  language: z
    .string()
    .describe(
      '2-letter language code in the [ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes) format.'
    )
    .optional()
    .nullable(),
  locale: z
    .string()
    .describe(
      'Locale in the [IETF BCP 47](https://en.wikipedia.org/wiki/IETF_language_tag) format.'
    )
    .optional()
    .nullable(),
  fullyCheckedIn: z
    .boolean()
    .describe('Whether all guests are checked in.')
    .optional()
    .nullable(),
  checkedInGuestCount: z
    .number()
    .int()
    .describe('Number of checked in guests.')
    .optional()
    .nullable(),
  additionalGuestDetails: z
    .object({
      guestCount: z
        .number()
        .int()
        .describe('Number of additional guests.')
        .min(0)
        .max(10)
        .optional()
        .nullable(),
      guestNames: z.array(z.string()).max(10).optional(),
    })
    .describe('Additional guest details.')
    .optional(),
  disableNotifications: z
    .boolean()
    .describe('Whether notifications are disabled.')
    .optional()
    .nullable(),
  onlineConferencingLogin: z
    .object({
      link: z
        .string()
        .describe('Link URL to the online conference.')
        .url()
        .optional(),
      password: z
        .string()
        .describe('Password for the online conference.')
        .optional()
        .nullable(),
    })
    .describe('Guest login details for accessing the online conference event.')
    .optional(),
  anonymized: z
    .boolean()
    .describe('Whether an RSVP is anonymized.')
    .optional()
    .nullable(),
  marketingConsent: z
    .boolean()
    .describe('Whether a guest agreed to marketing.')
    .optional()
    .nullable(),
  extendedFields: z
    .object({
      namespaces: z
        .record(z.string(), z.record(z.string(), z.any()))
        .describe(
          'Extended field data. Each key corresponds to the namespace of the app that created the extended fields.\nThe value of each key is structured according to the schema defined when the extended fields were configured.\n\nYou can only access fields for which you have the appropriate permissions.\n\nLearn more about [extended fields](https://dev.wix.com/docs/rest/articles/getting-started/extended-fields).'
        )
        .optional(),
    })
    .describe(
      "Custom field data for the RSVP object.\n\n**Note:** You must configure extended fields using schema plugin extensions in your app's dashboard before you can access the extended fields with API calls."
    )
    .optional(),
});
export const CreateRsvpRequest = z.object({
  rsvp: z
    .object({
      _id: z
        .string()
        .describe('ID of the RSVP.')
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional()
        .nullable(),
      revision: z
        .string()
        .regex(/^-?\d+$/, 'Must be a valid Int64 string')
        .describe(
          'Revision number, which increments by 1 each time the RSVP is updated. To prevent conflicting changes, the existing `revision` must be used when updating the RSVP.'
        )
        .optional()
        .nullable(),
      eventId: z
        .string()
        .describe('Event ID to which the RSVP belongs.')
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        ),
      _createdDate: z
        .date()
        .describe('Date and time the RSVP was created.')
        .optional()
        .nullable(),
      _updatedDate: z
        .date()
        .describe('Date and time the RSVP was updated.')
        .optional()
        .nullable(),
      memberId: z
        .string()
        .describe('Site member ID.')
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional()
        .nullable(),
      contactId: z
        .string()
        .describe(
          'Contact ID of a guest who filled in the RSVP form. See the Contacts API for more details.'
        )
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional()
        .nullable(),
      firstName: z
        .string()
        .describe('First name of a guest who filled in the RSVP form.')
        .min(1)
        .max(50),
      lastName: z
        .string()
        .describe('Last name of a guest who filled in the RSVP form.')
        .min(1)
        .max(50),
      email: z
        .string()
        .describe('Email of a guest who filled in the RSVP form.')
        .email()
        .min(4)
        .max(255),
      form: z
        .object({
          inputValues: z
            .array(
              z.object({
                inputName: z
                  .string()
                  .describe('Form field input name.')
                  .max(100)
                  .optional(),
                value: z
                  .string()
                  .describe('Form field value.')
                  .max(5000)
                  .optional(),
                values: z.array(z.string()).max(100).optional(),
              })
            )
            .max(200)
            .optional(),
        })
        .describe('Event registration form.')
        .optional(),
      status: z.enum(['YES', 'NO', 'WAITLIST']),
      totalGuests: z
        .number()
        .int()
        .describe('Total number of guests per 1 RSVP.')
        .optional()
        .nullable(),
      guestList: z
        .object({
          guests: z
            .array(
              z.object({
                index: z
                  .number()
                  .int()
                  .describe('Index of each guest in the array.')
                  .optional()
                  .nullable(),
                fullName: z
                  .string()
                  .describe('Full name.')
                  .max(101)
                  .optional()
                  .nullable(),
                checkInDetails: z
                  .object({
                    checkedIn: z
                      .boolean()
                      .describe('Whether the guest has checked in.')
                      .optional()
                      .nullable(),
                    checkInDate: z
                      .date()
                      .describe('Date and time the guest checked in.')
                      .optional()
                      .nullable(),
                    checkInCanceledDate: z
                      .date()
                      .describe('Date and time the guest cancelled check-in.')
                      .optional()
                      .nullable(),
                    checkedInBy: z
                      .string()
                      .describe('Id of the user who last performed check-in')
                      .regex(
                        /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                        'Must be a valid GUID'
                      )
                      .optional()
                      .nullable(),
                    checkInCanceledBy: z
                      .string()
                      .describe('Id of the user who last canceled check-in')
                      .regex(
                        /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                        'Must be a valid GUID'
                      )
                      .optional()
                      .nullable(),
                    checkedInByStaffMember: z
                      .string()
                      .describe(
                        'Id of the Staff Member who last performed check-in'
                      )
                      .regex(
                        /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                        'Must be a valid GUID'
                      )
                      .optional()
                      .nullable(),
                    checkInCanceledByStaffMember: z
                      .string()
                      .describe(
                        'Id of theStaff Member who last canceled check-in'
                      )
                      .regex(
                        /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                        'Must be a valid GUID'
                      )
                      .optional()
                      .nullable(),
                  })
                  .describe('Check-in details.')
                  .optional(),
                guestId: z
                  .number()
                  .int()
                  .describe('Guest ID.')
                  .min(1)
                  .optional()
                  .nullable(),
              })
            )
            .max(11)
            .optional(),
        })
        .describe('Guest list.')
        .optional(),
      language: z
        .string()
        .describe(
          '2-letter language code in the [ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes) format.'
        )
        .optional()
        .nullable(),
      locale: z
        .string()
        .describe(
          'Locale in the [IETF BCP 47](https://en.wikipedia.org/wiki/IETF_language_tag) format.'
        )
        .optional()
        .nullable(),
      fullyCheckedIn: z
        .boolean()
        .describe('Whether all guests are checked in.')
        .optional()
        .nullable(),
      checkedInGuestCount: z
        .number()
        .int()
        .describe('Number of checked in guests.')
        .optional()
        .nullable(),
      additionalGuestDetails: z
        .object({
          guestCount: z
            .number()
            .int()
            .describe('Number of additional guests.')
            .min(0)
            .max(10),
          guestNames: z.array(z.string()).max(10).optional(),
        })
        .describe('Additional guest details.')
        .optional(),
      disableNotifications: z
        .boolean()
        .describe('Whether notifications are disabled.')
        .optional()
        .nullable(),
      onlineConferencingLogin: z
        .object({
          link: z
            .string()
            .describe('Link URL to the online conference.')
            .url()
            .optional(),
          password: z
            .string()
            .describe('Password for the online conference.')
            .optional()
            .nullable(),
        })
        .describe(
          'Guest login details for accessing the online conference event.'
        )
        .optional(),
      anonymized: z
        .boolean()
        .describe('Whether an RSVP is anonymized.')
        .optional()
        .nullable(),
      marketingConsent: z
        .boolean()
        .describe('Whether a guest agreed to marketing.')
        .optional()
        .nullable(),
      extendedFields: z
        .object({
          namespaces: z
            .record(z.string(), z.record(z.string(), z.any()))
            .describe(
              'Extended field data. Each key corresponds to the namespace of the app that created the extended fields.\nThe value of each key is structured according to the schema defined when the extended fields were configured.\n\nYou can only access fields for which you have the appropriate permissions.\n\nLearn more about [extended fields](https://dev.wix.com/docs/rest/articles/getting-started/extended-fields).'
            )
            .optional(),
        })
        .describe(
          "Custom field data for the RSVP object.\n\n**Note:** You must configure extended fields using schema plugin extensions in your app's dashboard before you can access the extended fields with API calls."
        )
        .optional(),
    })
    .describe('RSVP info.'),
  options: z
    .object({
      options: z
        .object({
          ignoreLimits: z
            .boolean()
            .describe(
              "Whether to create or update an RSVP regardless of the event's guest limit."
            )
            .optional(),
          ignoreFormValidation: z
            .boolean()
            .describe('Whether to ignore the form validation.')
            .optional(),
          ignoreResponseStatus: z
            .boolean()
            .describe('Whether to ignore the response status.')
            .optional(),
          ignoreAdditionalGuestNames: z
            .boolean()
            .describe(
              'Whether to ignore the additional guest names validation.'
            )
            .optional(),
        })
        .describe(
          'RSVP options. <br> The **WIX_EVENTS.MANAGE_RSVP** permission is required.'
        )
        .optional(),
      fields: z
        .array(z.enum(['DETAILS', 'FORM', 'CONTACT_DETAILS']))
        .max(3)
        .optional(),
    })
    .optional(),
});
export const CreateRsvpResponse = z.object({
  _id: z
    .string()
    .describe('ID of the RSVP.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    )
    .optional()
    .nullable(),
  revision: z
    .string()
    .regex(/^-?\d+$/, 'Must be a valid Int64 string')
    .describe(
      'Revision number, which increments by 1 each time the RSVP is updated. To prevent conflicting changes, the existing `revision` must be used when updating the RSVP.'
    )
    .optional()
    .nullable(),
  eventId: z
    .string()
    .describe('Event ID to which the RSVP belongs.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    )
    .optional()
    .nullable(),
  _createdDate: z
    .date()
    .describe('Date and time the RSVP was created.')
    .optional()
    .nullable(),
  _updatedDate: z
    .date()
    .describe('Date and time the RSVP was updated.')
    .optional()
    .nullable(),
  memberId: z
    .string()
    .describe('Site member ID.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    )
    .optional()
    .nullable(),
  contactId: z
    .string()
    .describe(
      'Contact ID of a guest who filled in the RSVP form. See the Contacts API for more details.'
    )
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    )
    .optional()
    .nullable(),
  firstName: z
    .string()
    .describe('First name of a guest who filled in the RSVP form.')
    .min(1)
    .max(50)
    .optional()
    .nullable(),
  lastName: z
    .string()
    .describe('Last name of a guest who filled in the RSVP form.')
    .min(1)
    .max(50)
    .optional()
    .nullable(),
  email: z
    .string()
    .describe('Email of a guest who filled in the RSVP form.')
    .email()
    .min(4)
    .max(255)
    .optional()
    .nullable(),
  form: z
    .object({
      inputValues: z
        .array(
          z.object({
            inputName: z
              .string()
              .describe('Form field input name.')
              .max(100)
              .optional(),
            value: z
              .string()
              .describe('Form field value.')
              .max(5000)
              .optional(),
            values: z.array(z.string()).max(100).optional(),
          })
        )
        .max(200)
        .optional(),
    })
    .describe('Event registration form.')
    .optional(),
  status: z
    .enum(['YES', 'NO', 'WAITLIST'])
    .describe('RSVP response status.')
    .optional(),
  totalGuests: z
    .number()
    .int()
    .describe('Total number of guests per 1 RSVP.')
    .optional()
    .nullable(),
  guestList: z
    .object({
      guests: z
        .array(
          z.object({
            index: z
              .number()
              .int()
              .describe('Index of each guest in the array.')
              .optional()
              .nullable(),
            fullName: z
              .string()
              .describe('Full name.')
              .max(101)
              .optional()
              .nullable(),
            checkInDetails: z
              .object({
                checkedIn: z
                  .boolean()
                  .describe('Whether the guest has checked in.')
                  .optional()
                  .nullable(),
                checkInDate: z
                  .date()
                  .describe('Date and time the guest checked in.')
                  .optional()
                  .nullable(),
                checkInCanceledDate: z
                  .date()
                  .describe('Date and time the guest cancelled check-in.')
                  .optional()
                  .nullable(),
                checkedInBy: z
                  .string()
                  .describe('Id of the user who last performed check-in')
                  .regex(
                    /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                    'Must be a valid GUID'
                  )
                  .optional()
                  .nullable(),
                checkInCanceledBy: z
                  .string()
                  .describe('Id of the user who last canceled check-in')
                  .regex(
                    /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                    'Must be a valid GUID'
                  )
                  .optional()
                  .nullable(),
                checkedInByStaffMember: z
                  .string()
                  .describe(
                    'Id of the Staff Member who last performed check-in'
                  )
                  .regex(
                    /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                    'Must be a valid GUID'
                  )
                  .optional()
                  .nullable(),
                checkInCanceledByStaffMember: z
                  .string()
                  .describe('Id of theStaff Member who last canceled check-in')
                  .regex(
                    /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                    'Must be a valid GUID'
                  )
                  .optional()
                  .nullable(),
              })
              .describe('Check-in details.')
              .optional(),
            guestId: z
              .number()
              .int()
              .describe('Guest ID.')
              .min(1)
              .optional()
              .nullable(),
          })
        )
        .max(11)
        .optional(),
    })
    .describe('Guest list.')
    .optional(),
  language: z
    .string()
    .describe(
      '2-letter language code in the [ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes) format.'
    )
    .optional()
    .nullable(),
  locale: z
    .string()
    .describe(
      'Locale in the [IETF BCP 47](https://en.wikipedia.org/wiki/IETF_language_tag) format.'
    )
    .optional()
    .nullable(),
  fullyCheckedIn: z
    .boolean()
    .describe('Whether all guests are checked in.')
    .optional()
    .nullable(),
  checkedInGuestCount: z
    .number()
    .int()
    .describe('Number of checked in guests.')
    .optional()
    .nullable(),
  additionalGuestDetails: z
    .object({
      guestCount: z
        .number()
        .int()
        .describe('Number of additional guests.')
        .min(0)
        .max(10)
        .optional()
        .nullable(),
      guestNames: z.array(z.string()).max(10).optional(),
    })
    .describe('Additional guest details.')
    .optional(),
  disableNotifications: z
    .boolean()
    .describe('Whether notifications are disabled.')
    .optional()
    .nullable(),
  onlineConferencingLogin: z
    .object({
      link: z
        .string()
        .describe('Link URL to the online conference.')
        .url()
        .optional(),
      password: z
        .string()
        .describe('Password for the online conference.')
        .optional()
        .nullable(),
    })
    .describe('Guest login details for accessing the online conference event.')
    .optional(),
  anonymized: z
    .boolean()
    .describe('Whether an RSVP is anonymized.')
    .optional()
    .nullable(),
  marketingConsent: z
    .boolean()
    .describe('Whether a guest agreed to marketing.')
    .optional()
    .nullable(),
  extendedFields: z
    .object({
      namespaces: z
        .record(z.string(), z.record(z.string(), z.any()))
        .describe(
          'Extended field data. Each key corresponds to the namespace of the app that created the extended fields.\nThe value of each key is structured according to the schema defined when the extended fields were configured.\n\nYou can only access fields for which you have the appropriate permissions.\n\nLearn more about [extended fields](https://dev.wix.com/docs/rest/articles/getting-started/extended-fields).'
        )
        .optional(),
    })
    .describe(
      "Custom field data for the RSVP object.\n\n**Note:** You must configure extended fields using schema plugin extensions in your app's dashboard before you can access the extended fields with API calls."
    )
    .optional(),
});
export const UpdateRsvpRequest = z.object({
  _id: z
    .string()
    .describe('ID of the RSVP.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    ),
  rsvp: z
    .object({
      _id: z
        .string()
        .describe('ID of the RSVP.')
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional()
        .nullable(),
      revision: z
        .string()
        .regex(/^-?\d+$/, 'Must be a valid Int64 string')
        .describe(
          'Revision number, which increments by 1 each time the RSVP is updated. To prevent conflicting changes, the existing `revision` must be used when updating the RSVP.'
        )
        .optional()
        .nullable(),
      eventId: z
        .string()
        .describe('Event ID to which the RSVP belongs.')
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional()
        .nullable(),
      _createdDate: z
        .date()
        .describe('Date and time the RSVP was created.')
        .optional()
        .nullable(),
      _updatedDate: z
        .date()
        .describe('Date and time the RSVP was updated.')
        .optional()
        .nullable(),
      memberId: z
        .string()
        .describe('Site member ID.')
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional()
        .nullable(),
      contactId: z
        .string()
        .describe(
          'Contact ID of a guest who filled in the RSVP form. See the Contacts API for more details.'
        )
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional()
        .nullable(),
      firstName: z
        .string()
        .describe('First name of a guest who filled in the RSVP form.')
        .min(1)
        .max(50)
        .optional()
        .nullable(),
      lastName: z
        .string()
        .describe('Last name of a guest who filled in the RSVP form.')
        .min(1)
        .max(50)
        .optional()
        .nullable(),
      email: z
        .string()
        .describe('Email of a guest who filled in the RSVP form.')
        .email()
        .min(4)
        .max(255)
        .optional()
        .nullable(),
      form: z
        .object({
          inputValues: z
            .array(
              z.object({
                inputName: z
                  .string()
                  .describe('Form field input name.')
                  .max(100)
                  .optional(),
                value: z
                  .string()
                  .describe('Form field value.')
                  .max(5000)
                  .optional(),
                values: z.array(z.string()).max(100).optional(),
              })
            )
            .max(200)
            .optional(),
        })
        .describe('Event registration form.')
        .optional(),
      status: z.enum(['YES', 'NO', 'WAITLIST']).optional(),
      totalGuests: z
        .number()
        .int()
        .describe('Total number of guests per 1 RSVP.')
        .optional()
        .nullable(),
      guestList: z
        .object({
          guests: z
            .array(
              z.object({
                index: z
                  .number()
                  .int()
                  .describe('Index of each guest in the array.')
                  .optional()
                  .nullable(),
                fullName: z
                  .string()
                  .describe('Full name.')
                  .max(101)
                  .optional()
                  .nullable(),
                checkInDetails: z
                  .object({
                    checkedIn: z
                      .boolean()
                      .describe('Whether the guest has checked in.')
                      .optional()
                      .nullable(),
                    checkInDate: z
                      .date()
                      .describe('Date and time the guest checked in.')
                      .optional()
                      .nullable(),
                    checkInCanceledDate: z
                      .date()
                      .describe('Date and time the guest cancelled check-in.')
                      .optional()
                      .nullable(),
                    checkedInBy: z
                      .string()
                      .describe('Id of the user who last performed check-in')
                      .regex(
                        /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                        'Must be a valid GUID'
                      )
                      .optional()
                      .nullable(),
                    checkInCanceledBy: z
                      .string()
                      .describe('Id of the user who last canceled check-in')
                      .regex(
                        /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                        'Must be a valid GUID'
                      )
                      .optional()
                      .nullable(),
                    checkedInByStaffMember: z
                      .string()
                      .describe(
                        'Id of the Staff Member who last performed check-in'
                      )
                      .regex(
                        /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                        'Must be a valid GUID'
                      )
                      .optional()
                      .nullable(),
                    checkInCanceledByStaffMember: z
                      .string()
                      .describe(
                        'Id of theStaff Member who last canceled check-in'
                      )
                      .regex(
                        /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                        'Must be a valid GUID'
                      )
                      .optional()
                      .nullable(),
                  })
                  .describe('Check-in details.')
                  .optional(),
                guestId: z
                  .number()
                  .int()
                  .describe('Guest ID.')
                  .min(1)
                  .optional()
                  .nullable(),
              })
            )
            .max(11)
            .optional(),
        })
        .describe('Guest list.')
        .optional(),
      language: z
        .string()
        .describe(
          '2-letter language code in the [ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes) format.'
        )
        .optional()
        .nullable(),
      locale: z
        .string()
        .describe(
          'Locale in the [IETF BCP 47](https://en.wikipedia.org/wiki/IETF_language_tag) format.'
        )
        .optional()
        .nullable(),
      fullyCheckedIn: z
        .boolean()
        .describe('Whether all guests are checked in.')
        .optional()
        .nullable(),
      checkedInGuestCount: z
        .number()
        .int()
        .describe('Number of checked in guests.')
        .optional()
        .nullable(),
      additionalGuestDetails: z
        .object({
          guestCount: z
            .number()
            .int()
            .describe('Number of additional guests.')
            .min(0)
            .max(10)
            .optional()
            .nullable(),
          guestNames: z.array(z.string()).max(10).optional(),
        })
        .describe('Additional guest details.')
        .optional(),
      disableNotifications: z
        .boolean()
        .describe('Whether notifications are disabled.')
        .optional()
        .nullable(),
      onlineConferencingLogin: z
        .object({
          link: z
            .string()
            .describe('Link URL to the online conference.')
            .url()
            .optional(),
          password: z
            .string()
            .describe('Password for the online conference.')
            .optional()
            .nullable(),
        })
        .describe(
          'Guest login details for accessing the online conference event.'
        )
        .optional(),
      anonymized: z
        .boolean()
        .describe('Whether an RSVP is anonymized.')
        .optional()
        .nullable(),
      marketingConsent: z
        .boolean()
        .describe('Whether a guest agreed to marketing.')
        .optional()
        .nullable(),
      extendedFields: z
        .object({
          namespaces: z
            .record(z.string(), z.record(z.string(), z.any()))
            .describe(
              'Extended field data. Each key corresponds to the namespace of the app that created the extended fields.\nThe value of each key is structured according to the schema defined when the extended fields were configured.\n\nYou can only access fields for which you have the appropriate permissions.\n\nLearn more about [extended fields](https://dev.wix.com/docs/rest/articles/getting-started/extended-fields).'
            )
            .optional(),
        })
        .describe(
          "Custom field data for the RSVP object.\n\n**Note:** You must configure extended fields using schema plugin extensions in your app's dashboard before you can access the extended fields with API calls."
        )
        .optional(),
    })
    .describe('RSVP to update.'),
  options: z.object({
    options: z
      .object({
        ignoreLimits: z
          .boolean()
          .describe(
            "Whether to create or update an RSVP regardless of the event's guest limit."
          )
          .optional(),
        ignoreFormValidation: z
          .boolean()
          .describe('Whether to ignore the form validation.')
          .optional(),
        ignoreResponseStatus: z
          .boolean()
          .describe('Whether to ignore the response status.')
          .optional(),
        ignoreAdditionalGuestNames: z
          .boolean()
          .describe('Whether to ignore the additional guest names validation.')
          .optional(),
      })
      .describe(
        'RSVP options. <br> The **WIX_EVENTS.MANAGE_RSVP** permission is required to pass these fields.'
      )
      .optional(),
    fields: z
      .array(z.enum(['DETAILS', 'FORM', 'CONTACT_DETAILS']))
      .max(3)
      .optional(),
  }),
});
export const UpdateRsvpResponse = z.object({
  _id: z
    .string()
    .describe('ID of the RSVP.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    )
    .optional()
    .nullable(),
  revision: z
    .string()
    .regex(/^-?\d+$/, 'Must be a valid Int64 string')
    .describe(
      'Revision number, which increments by 1 each time the RSVP is updated. To prevent conflicting changes, the existing `revision` must be used when updating the RSVP.'
    )
    .optional()
    .nullable(),
  eventId: z
    .string()
    .describe('Event ID to which the RSVP belongs.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    )
    .optional()
    .nullable(),
  _createdDate: z
    .date()
    .describe('Date and time the RSVP was created.')
    .optional()
    .nullable(),
  _updatedDate: z
    .date()
    .describe('Date and time the RSVP was updated.')
    .optional()
    .nullable(),
  memberId: z
    .string()
    .describe('Site member ID.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    )
    .optional()
    .nullable(),
  contactId: z
    .string()
    .describe(
      'Contact ID of a guest who filled in the RSVP form. See the Contacts API for more details.'
    )
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    )
    .optional()
    .nullable(),
  firstName: z
    .string()
    .describe('First name of a guest who filled in the RSVP form.')
    .min(1)
    .max(50)
    .optional()
    .nullable(),
  lastName: z
    .string()
    .describe('Last name of a guest who filled in the RSVP form.')
    .min(1)
    .max(50)
    .optional()
    .nullable(),
  email: z
    .string()
    .describe('Email of a guest who filled in the RSVP form.')
    .email()
    .min(4)
    .max(255)
    .optional()
    .nullable(),
  form: z
    .object({
      inputValues: z
        .array(
          z.object({
            inputName: z
              .string()
              .describe('Form field input name.')
              .max(100)
              .optional(),
            value: z
              .string()
              .describe('Form field value.')
              .max(5000)
              .optional(),
            values: z.array(z.string()).max(100).optional(),
          })
        )
        .max(200)
        .optional(),
    })
    .describe('Event registration form.')
    .optional(),
  status: z
    .enum(['YES', 'NO', 'WAITLIST'])
    .describe('RSVP response status.')
    .optional(),
  totalGuests: z
    .number()
    .int()
    .describe('Total number of guests per 1 RSVP.')
    .optional()
    .nullable(),
  guestList: z
    .object({
      guests: z
        .array(
          z.object({
            index: z
              .number()
              .int()
              .describe('Index of each guest in the array.')
              .optional()
              .nullable(),
            fullName: z
              .string()
              .describe('Full name.')
              .max(101)
              .optional()
              .nullable(),
            checkInDetails: z
              .object({
                checkedIn: z
                  .boolean()
                  .describe('Whether the guest has checked in.')
                  .optional()
                  .nullable(),
                checkInDate: z
                  .date()
                  .describe('Date and time the guest checked in.')
                  .optional()
                  .nullable(),
                checkInCanceledDate: z
                  .date()
                  .describe('Date and time the guest cancelled check-in.')
                  .optional()
                  .nullable(),
                checkedInBy: z
                  .string()
                  .describe('Id of the user who last performed check-in')
                  .regex(
                    /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                    'Must be a valid GUID'
                  )
                  .optional()
                  .nullable(),
                checkInCanceledBy: z
                  .string()
                  .describe('Id of the user who last canceled check-in')
                  .regex(
                    /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                    'Must be a valid GUID'
                  )
                  .optional()
                  .nullable(),
                checkedInByStaffMember: z
                  .string()
                  .describe(
                    'Id of the Staff Member who last performed check-in'
                  )
                  .regex(
                    /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                    'Must be a valid GUID'
                  )
                  .optional()
                  .nullable(),
                checkInCanceledByStaffMember: z
                  .string()
                  .describe('Id of theStaff Member who last canceled check-in')
                  .regex(
                    /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                    'Must be a valid GUID'
                  )
                  .optional()
                  .nullable(),
              })
              .describe('Check-in details.')
              .optional(),
            guestId: z
              .number()
              .int()
              .describe('Guest ID.')
              .min(1)
              .optional()
              .nullable(),
          })
        )
        .max(11)
        .optional(),
    })
    .describe('Guest list.')
    .optional(),
  language: z
    .string()
    .describe(
      '2-letter language code in the [ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes) format.'
    )
    .optional()
    .nullable(),
  locale: z
    .string()
    .describe(
      'Locale in the [IETF BCP 47](https://en.wikipedia.org/wiki/IETF_language_tag) format.'
    )
    .optional()
    .nullable(),
  fullyCheckedIn: z
    .boolean()
    .describe('Whether all guests are checked in.')
    .optional()
    .nullable(),
  checkedInGuestCount: z
    .number()
    .int()
    .describe('Number of checked in guests.')
    .optional()
    .nullable(),
  additionalGuestDetails: z
    .object({
      guestCount: z
        .number()
        .int()
        .describe('Number of additional guests.')
        .min(0)
        .max(10)
        .optional()
        .nullable(),
      guestNames: z.array(z.string()).max(10).optional(),
    })
    .describe('Additional guest details.')
    .optional(),
  disableNotifications: z
    .boolean()
    .describe('Whether notifications are disabled.')
    .optional()
    .nullable(),
  onlineConferencingLogin: z
    .object({
      link: z
        .string()
        .describe('Link URL to the online conference.')
        .url()
        .optional(),
      password: z
        .string()
        .describe('Password for the online conference.')
        .optional()
        .nullable(),
    })
    .describe('Guest login details for accessing the online conference event.')
    .optional(),
  anonymized: z
    .boolean()
    .describe('Whether an RSVP is anonymized.')
    .optional()
    .nullable(),
  marketingConsent: z
    .boolean()
    .describe('Whether a guest agreed to marketing.')
    .optional()
    .nullable(),
  extendedFields: z
    .object({
      namespaces: z
        .record(z.string(), z.record(z.string(), z.any()))
        .describe(
          'Extended field data. Each key corresponds to the namespace of the app that created the extended fields.\nThe value of each key is structured according to the schema defined when the extended fields were configured.\n\nYou can only access fields for which you have the appropriate permissions.\n\nLearn more about [extended fields](https://dev.wix.com/docs/rest/articles/getting-started/extended-fields).'
        )
        .optional(),
    })
    .describe(
      "Custom field data for the RSVP object.\n\n**Note:** You must configure extended fields using schema plugin extensions in your app's dashboard before you can access the extended fields with API calls."
    )
    .optional(),
});
export const DeleteRsvpRequest = z.object({
  rsvpId: z
    .string()
    .describe('ID of the RSVP to delete.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    ),
});
export const DeleteRsvpResponse = z.object({});
export const BulkUpdateRsvpsRequest = z.object({
  rsvps: z
    .array(
      z.object({
        rsvp: z
          .object({
            _id: z
              .string()
              .describe('ID of the RSVP.')
              .regex(
                /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                'Must be a valid GUID'
              ),
            revision: z
              .string()
              .regex(/^-?\d+$/, 'Must be a valid Int64 string')
              .describe(
                'Revision number, which increments by 1 each time the RSVP is updated. To prevent conflicting changes, the existing `revision` must be used when updating the RSVP.'
              ),
            eventId: z
              .string()
              .describe('Event ID to which the RSVP belongs.')
              .regex(
                /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                'Must be a valid GUID'
              )
              .optional()
              .nullable(),
            _createdDate: z
              .date()
              .describe('Date and time the RSVP was created.')
              .optional()
              .nullable(),
            _updatedDate: z
              .date()
              .describe('Date and time the RSVP was updated.')
              .optional()
              .nullable(),
            memberId: z
              .string()
              .describe('Site member ID.')
              .regex(
                /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                'Must be a valid GUID'
              )
              .optional()
              .nullable(),
            contactId: z
              .string()
              .describe(
                'Contact ID of a guest who filled in the RSVP form. See the Contacts API for more details.'
              )
              .regex(
                /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                'Must be a valid GUID'
              )
              .optional()
              .nullable(),
            firstName: z
              .string()
              .describe('First name of a guest who filled in the RSVP form.')
              .min(1)
              .max(50)
              .optional()
              .nullable(),
            lastName: z
              .string()
              .describe('Last name of a guest who filled in the RSVP form.')
              .min(1)
              .max(50)
              .optional()
              .nullable(),
            email: z
              .string()
              .describe('Email of a guest who filled in the RSVP form.')
              .email()
              .min(4)
              .max(255)
              .optional()
              .nullable(),
            form: z
              .object({
                inputValues: z
                  .array(
                    z.object({
                      inputName: z
                        .string()
                        .describe('Form field input name.')
                        .max(100)
                        .optional(),
                      value: z
                        .string()
                        .describe('Form field value.')
                        .max(5000)
                        .optional(),
                      values: z.array(z.string()).max(100).optional(),
                    })
                  )
                  .max(200)
                  .optional(),
              })
              .describe('Event registration form.')
              .optional(),
            status: z.enum(['YES', 'NO', 'WAITLIST']).optional(),
            totalGuests: z
              .number()
              .int()
              .describe('Total number of guests per 1 RSVP.')
              .optional()
              .nullable(),
            guestList: z
              .object({
                guests: z
                  .array(
                    z.object({
                      index: z
                        .number()
                        .int()
                        .describe('Index of each guest in the array.')
                        .optional()
                        .nullable(),
                      fullName: z
                        .string()
                        .describe('Full name.')
                        .max(101)
                        .optional()
                        .nullable(),
                      checkInDetails: z
                        .object({
                          checkedIn: z
                            .boolean()
                            .describe('Whether the guest has checked in.')
                            .optional()
                            .nullable(),
                          checkInDate: z
                            .date()
                            .describe('Date and time the guest checked in.')
                            .optional()
                            .nullable(),
                          checkInCanceledDate: z
                            .date()
                            .describe(
                              'Date and time the guest cancelled check-in.'
                            )
                            .optional()
                            .nullable(),
                          checkedInBy: z
                            .string()
                            .describe(
                              'Id of the user who last performed check-in'
                            )
                            .regex(
                              /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                              'Must be a valid GUID'
                            )
                            .optional()
                            .nullable(),
                          checkInCanceledBy: z
                            .string()
                            .describe(
                              'Id of the user who last canceled check-in'
                            )
                            .regex(
                              /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                              'Must be a valid GUID'
                            )
                            .optional()
                            .nullable(),
                          checkedInByStaffMember: z
                            .string()
                            .describe(
                              'Id of the Staff Member who last performed check-in'
                            )
                            .regex(
                              /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                              'Must be a valid GUID'
                            )
                            .optional()
                            .nullable(),
                          checkInCanceledByStaffMember: z
                            .string()
                            .describe(
                              'Id of theStaff Member who last canceled check-in'
                            )
                            .regex(
                              /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                              'Must be a valid GUID'
                            )
                            .optional()
                            .nullable(),
                        })
                        .describe('Check-in details.')
                        .optional(),
                      guestId: z
                        .number()
                        .int()
                        .describe('Guest ID.')
                        .min(1)
                        .optional()
                        .nullable(),
                    })
                  )
                  .max(11)
                  .optional(),
              })
              .describe('Guest list.')
              .optional(),
            language: z
              .string()
              .describe(
                '2-letter language code in the [ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes) format.'
              )
              .optional()
              .nullable(),
            locale: z
              .string()
              .describe(
                'Locale in the [IETF BCP 47](https://en.wikipedia.org/wiki/IETF_language_tag) format.'
              )
              .optional()
              .nullable(),
            fullyCheckedIn: z
              .boolean()
              .describe('Whether all guests are checked in.')
              .optional()
              .nullable(),
            checkedInGuestCount: z
              .number()
              .int()
              .describe('Number of checked in guests.')
              .optional()
              .nullable(),
            additionalGuestDetails: z
              .object({
                guestCount: z
                  .number()
                  .int()
                  .describe('Number of additional guests.')
                  .min(0)
                  .max(10)
                  .optional()
                  .nullable(),
                guestNames: z.array(z.string()).max(10).optional(),
              })
              .describe('Additional guest details.')
              .optional(),
            disableNotifications: z
              .boolean()
              .describe('Whether notifications are disabled.')
              .optional()
              .nullable(),
            onlineConferencingLogin: z
              .object({
                link: z
                  .string()
                  .describe('Link URL to the online conference.')
                  .url()
                  .optional(),
                password: z
                  .string()
                  .describe('Password for the online conference.')
                  .optional()
                  .nullable(),
              })
              .describe(
                'Guest login details for accessing the online conference event.'
              )
              .optional(),
            anonymized: z
              .boolean()
              .describe('Whether an RSVP is anonymized.')
              .optional()
              .nullable(),
            marketingConsent: z
              .boolean()
              .describe('Whether a guest agreed to marketing.')
              .optional()
              .nullable(),
            extendedFields: z
              .object({
                namespaces: z
                  .record(z.string(), z.record(z.string(), z.any()))
                  .describe(
                    'Extended field data. Each key corresponds to the namespace of the app that created the extended fields.\nThe value of each key is structured according to the schema defined when the extended fields were configured.\n\nYou can only access fields for which you have the appropriate permissions.\n\nLearn more about [extended fields](https://dev.wix.com/docs/rest/articles/getting-started/extended-fields).'
                  )
                  .optional(),
              })
              .describe(
                "Custom field data for the RSVP object.\n\n**Note:** You must configure extended fields using schema plugin extensions in your app's dashboard before you can access the extended fields with API calls."
              )
              .optional(),
          })
          .describe('RSVP to update.')
          .optional(),
        fieldMask: z.array(z.string()).optional(),
      })
    )
    .min(1)
    .max(100),
  options: z
    .object({
      returnEntity: z
        .boolean()
        .describe(
          'Whether to return the whole `rsvp` object in the response. If `false`, only metadata is returned.'
        )
        .optional(),
      fields: z
        .array(z.enum(['DETAILS', 'FORM', 'CONTACT_DETAILS']))
        .max(3)
        .optional(),
      options: z
        .object({
          ignoreLimits: z
            .boolean()
            .describe(
              "Whether to create or update an RSVP regardless of the event's guest limit."
            )
            .optional(),
          ignoreFormValidation: z
            .boolean()
            .describe('Whether to ignore the form validation.')
            .optional(),
          ignoreResponseStatus: z
            .boolean()
            .describe('Whether to ignore the response status.')
            .optional(),
          ignoreAdditionalGuestNames: z
            .boolean()
            .describe(
              'Whether to ignore the additional guest names validation.'
            )
            .optional(),
        })
        .describe(
          'RSVP options. <br> The **WIX_EVENTS.MANAGE_RSVP** permission is required to pass these fields.'
        )
        .optional(),
    })
    .optional(),
});
export const BulkUpdateRsvpsResponse = z.object({
  results: z
    .array(
      z.object({
        itemMetadata: z
          .object({
            _id: z
              .string()
              .describe(
                "Item ID. Should always be available, unless it's impossible (for example, when failing to create an item)."
              )
              .regex(
                /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                'Must be a valid GUID'
              )
              .optional()
              .nullable(),
            originalIndex: z
              .number()
              .int()
              .describe(
                'Index of the item within the request array. Allows for correlation between request and response items.'
              )
              .optional(),
            success: z
              .boolean()
              .describe(
                'Whether the requested action was successful for this item. When `false`, the `error` field is populated.'
              )
              .optional(),
            error: z
              .object({
                code: z.string().describe('Error code.').optional(),
                description: z
                  .string()
                  .describe('Description of the error.')
                  .optional(),
                data: z
                  .record(z.string(), z.any())
                  .describe('Data related to the error.')
                  .optional()
                  .nullable(),
              })
              .describe('Details about the error in case of failure.')
              .optional(),
          })
          .describe('Item metadata.')
          .optional(),
        rsvp: z
          .object({
            _id: z
              .string()
              .describe('ID of the RSVP.')
              .regex(
                /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                'Must be a valid GUID'
              )
              .optional()
              .nullable(),
            revision: z
              .string()
              .regex(/^-?\d+$/, 'Must be a valid Int64 string')
              .describe(
                'Revision number, which increments by 1 each time the RSVP is updated. To prevent conflicting changes, the existing `revision` must be used when updating the RSVP.'
              )
              .optional()
              .nullable(),
            eventId: z
              .string()
              .describe('Event ID to which the RSVP belongs.')
              .regex(
                /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                'Must be a valid GUID'
              )
              .optional()
              .nullable(),
            _createdDate: z
              .date()
              .describe('Date and time the RSVP was created.')
              .optional()
              .nullable(),
            _updatedDate: z
              .date()
              .describe('Date and time the RSVP was updated.')
              .optional()
              .nullable(),
            memberId: z
              .string()
              .describe('Site member ID.')
              .regex(
                /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                'Must be a valid GUID'
              )
              .optional()
              .nullable(),
            contactId: z
              .string()
              .describe(
                'Contact ID of a guest who filled in the RSVP form. See the Contacts API for more details.'
              )
              .regex(
                /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                'Must be a valid GUID'
              )
              .optional()
              .nullable(),
            firstName: z
              .string()
              .describe('First name of a guest who filled in the RSVP form.')
              .min(1)
              .max(50)
              .optional()
              .nullable(),
            lastName: z
              .string()
              .describe('Last name of a guest who filled in the RSVP form.')
              .min(1)
              .max(50)
              .optional()
              .nullable(),
            email: z
              .string()
              .describe('Email of a guest who filled in the RSVP form.')
              .email()
              .min(4)
              .max(255)
              .optional()
              .nullable(),
            form: z
              .object({
                inputValues: z
                  .array(
                    z.object({
                      inputName: z
                        .string()
                        .describe('Form field input name.')
                        .max(100)
                        .optional(),
                      value: z
                        .string()
                        .describe('Form field value.')
                        .max(5000)
                        .optional(),
                      values: z.array(z.string()).max(100).optional(),
                    })
                  )
                  .max(200)
                  .optional(),
              })
              .describe('Event registration form.')
              .optional(),
            status: z
              .enum(['YES', 'NO', 'WAITLIST'])
              .describe('RSVP response status.')
              .optional(),
            totalGuests: z
              .number()
              .int()
              .describe('Total number of guests per 1 RSVP.')
              .optional()
              .nullable(),
            guestList: z
              .object({
                guests: z
                  .array(
                    z.object({
                      index: z
                        .number()
                        .int()
                        .describe('Index of each guest in the array.')
                        .optional()
                        .nullable(),
                      fullName: z
                        .string()
                        .describe('Full name.')
                        .max(101)
                        .optional()
                        .nullable(),
                      checkInDetails: z
                        .object({
                          checkedIn: z
                            .boolean()
                            .describe('Whether the guest has checked in.')
                            .optional()
                            .nullable(),
                          checkInDate: z
                            .date()
                            .describe('Date and time the guest checked in.')
                            .optional()
                            .nullable(),
                          checkInCanceledDate: z
                            .date()
                            .describe(
                              'Date and time the guest cancelled check-in.'
                            )
                            .optional()
                            .nullable(),
                          checkedInBy: z
                            .string()
                            .describe(
                              'Id of the user who last performed check-in'
                            )
                            .regex(
                              /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                              'Must be a valid GUID'
                            )
                            .optional()
                            .nullable(),
                          checkInCanceledBy: z
                            .string()
                            .describe(
                              'Id of the user who last canceled check-in'
                            )
                            .regex(
                              /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                              'Must be a valid GUID'
                            )
                            .optional()
                            .nullable(),
                          checkedInByStaffMember: z
                            .string()
                            .describe(
                              'Id of the Staff Member who last performed check-in'
                            )
                            .regex(
                              /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                              'Must be a valid GUID'
                            )
                            .optional()
                            .nullable(),
                          checkInCanceledByStaffMember: z
                            .string()
                            .describe(
                              'Id of theStaff Member who last canceled check-in'
                            )
                            .regex(
                              /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                              'Must be a valid GUID'
                            )
                            .optional()
                            .nullable(),
                        })
                        .describe('Check-in details.')
                        .optional(),
                      guestId: z
                        .number()
                        .int()
                        .describe('Guest ID.')
                        .min(1)
                        .optional()
                        .nullable(),
                    })
                  )
                  .max(11)
                  .optional(),
              })
              .describe('Guest list.')
              .optional(),
            language: z
              .string()
              .describe(
                '2-letter language code in the [ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes) format.'
              )
              .optional()
              .nullable(),
            locale: z
              .string()
              .describe(
                'Locale in the [IETF BCP 47](https://en.wikipedia.org/wiki/IETF_language_tag) format.'
              )
              .optional()
              .nullable(),
            fullyCheckedIn: z
              .boolean()
              .describe('Whether all guests are checked in.')
              .optional()
              .nullable(),
            checkedInGuestCount: z
              .number()
              .int()
              .describe('Number of checked in guests.')
              .optional()
              .nullable(),
            additionalGuestDetails: z
              .object({
                guestCount: z
                  .number()
                  .int()
                  .describe('Number of additional guests.')
                  .min(0)
                  .max(10)
                  .optional()
                  .nullable(),
                guestNames: z.array(z.string()).max(10).optional(),
              })
              .describe('Additional guest details.')
              .optional(),
            disableNotifications: z
              .boolean()
              .describe('Whether notifications are disabled.')
              .optional()
              .nullable(),
            onlineConferencingLogin: z
              .object({
                link: z
                  .string()
                  .describe('Link URL to the online conference.')
                  .url()
                  .optional(),
                password: z
                  .string()
                  .describe('Password for the online conference.')
                  .optional()
                  .nullable(),
              })
              .describe(
                'Guest login details for accessing the online conference event.'
              )
              .optional(),
            anonymized: z
              .boolean()
              .describe('Whether an RSVP is anonymized.')
              .optional()
              .nullable(),
            marketingConsent: z
              .boolean()
              .describe('Whether a guest agreed to marketing.')
              .optional()
              .nullable(),
            extendedFields: z
              .object({
                namespaces: z
                  .record(z.string(), z.record(z.string(), z.any()))
                  .describe(
                    'Extended field data. Each key corresponds to the namespace of the app that created the extended fields.\nThe value of each key is structured according to the schema defined when the extended fields were configured.\n\nYou can only access fields for which you have the appropriate permissions.\n\nLearn more about [extended fields](https://dev.wix.com/docs/rest/articles/getting-started/extended-fields).'
                  )
                  .optional(),
              })
              .describe(
                "Custom field data for the RSVP object.\n\n**Note:** You must configure extended fields using schema plugin extensions in your app's dashboard before you can access the extended fields with API calls."
              )
              .optional(),
          })
          .describe('Updated RSVP.')
          .optional(),
      })
    )
    .min(1)
    .max(100)
    .optional(),
  bulkActionMetadata: z
    .object({
      totalSuccesses: z
        .number()
        .int()
        .describe('Number of items that were successfully processed.')
        .optional(),
      totalFailures: z
        .number()
        .int()
        .describe("Number of items that couldn't be processed.")
        .optional(),
      undetailedFailures: z
        .number()
        .int()
        .describe(
          'Number of failures without details because detailed failure threshold was exceeded.'
        )
        .optional(),
    })
    .describe('Response metadata.')
    .optional(),
});
export const BulkDeleteRsvpsByFilterRequest = z.object({
  filter: z.record(z.string(), z.any()).describe('Filter object.'),
  options: z
    .object({
      search: z
        .object({
          mode: z.enum(['OR', 'AND']).optional(),
          expression: z
            .string()
            .describe('Search term or expression.')
            .max(100)
            .optional()
            .nullable(),
          fields: z.array(z.string()).max(20).optional(),
          fuzzy: z
            .boolean()
            .describe(
              'Whether to enable the search function to use an algorithm to automatically find results that are close to the search expression, such as typos and declensions.'
            )
            .optional(),
        })
        .describe('Search details.')
        .optional(),
    })
    .optional(),
});
export const BulkDeleteRsvpsByFilterResponse = z.object({
  jobId: z
    .string()
    .describe(
      'Job ID. Call [Get Async Job](https://dev.wix.com/docs/rest/business-management/async-job/get-async-job) with this ID to retrieve the job details and metadata.'
    )
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    )
    .optional(),
});
export const CheckInRsvpGuestsRequest = z.object({
  rsvpId: z
    .string()
    .describe('ID of the RSVP to check-in.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    ),
  options: z
    .object({
      guestIds: z.array(z.number().int()).min(1).max(11).optional(),
      fields: z
        .array(z.enum(['DETAILS', 'FORM', 'CONTACT_DETAILS']))
        .max(3)
        .optional(),
    })
    .optional(),
});
export const CheckInRsvpGuestsResponse = z.object({
  rsvp: z
    .object({
      _id: z
        .string()
        .describe('ID of the RSVP.')
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional()
        .nullable(),
      revision: z
        .string()
        .regex(/^-?\d+$/, 'Must be a valid Int64 string')
        .describe(
          'Revision number, which increments by 1 each time the RSVP is updated. To prevent conflicting changes, the existing `revision` must be used when updating the RSVP.'
        )
        .optional()
        .nullable(),
      eventId: z
        .string()
        .describe('Event ID to which the RSVP belongs.')
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional()
        .nullable(),
      _createdDate: z
        .date()
        .describe('Date and time the RSVP was created.')
        .optional()
        .nullable(),
      _updatedDate: z
        .date()
        .describe('Date and time the RSVP was updated.')
        .optional()
        .nullable(),
      memberId: z
        .string()
        .describe('Site member ID.')
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional()
        .nullable(),
      contactId: z
        .string()
        .describe(
          'Contact ID of a guest who filled in the RSVP form. See the Contacts API for more details.'
        )
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional()
        .nullable(),
      firstName: z
        .string()
        .describe('First name of a guest who filled in the RSVP form.')
        .min(1)
        .max(50)
        .optional()
        .nullable(),
      lastName: z
        .string()
        .describe('Last name of a guest who filled in the RSVP form.')
        .min(1)
        .max(50)
        .optional()
        .nullable(),
      email: z
        .string()
        .describe('Email of a guest who filled in the RSVP form.')
        .email()
        .min(4)
        .max(255)
        .optional()
        .nullable(),
      form: z
        .object({
          inputValues: z
            .array(
              z.object({
                inputName: z
                  .string()
                  .describe('Form field input name.')
                  .max(100)
                  .optional(),
                value: z
                  .string()
                  .describe('Form field value.')
                  .max(5000)
                  .optional(),
                values: z.array(z.string()).max(100).optional(),
              })
            )
            .max(200)
            .optional(),
        })
        .describe('Event registration form.')
        .optional(),
      status: z
        .enum(['YES', 'NO', 'WAITLIST'])
        .describe('RSVP response status.')
        .optional(),
      totalGuests: z
        .number()
        .int()
        .describe('Total number of guests per 1 RSVP.')
        .optional()
        .nullable(),
      guestList: z
        .object({
          guests: z
            .array(
              z.object({
                index: z
                  .number()
                  .int()
                  .describe('Index of each guest in the array.')
                  .optional()
                  .nullable(),
                fullName: z
                  .string()
                  .describe('Full name.')
                  .max(101)
                  .optional()
                  .nullable(),
                checkInDetails: z
                  .object({
                    checkedIn: z
                      .boolean()
                      .describe('Whether the guest has checked in.')
                      .optional()
                      .nullable(),
                    checkInDate: z
                      .date()
                      .describe('Date and time the guest checked in.')
                      .optional()
                      .nullable(),
                    checkInCanceledDate: z
                      .date()
                      .describe('Date and time the guest cancelled check-in.')
                      .optional()
                      .nullable(),
                    checkedInBy: z
                      .string()
                      .describe('Id of the user who last performed check-in')
                      .regex(
                        /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                        'Must be a valid GUID'
                      )
                      .optional()
                      .nullable(),
                    checkInCanceledBy: z
                      .string()
                      .describe('Id of the user who last canceled check-in')
                      .regex(
                        /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                        'Must be a valid GUID'
                      )
                      .optional()
                      .nullable(),
                    checkedInByStaffMember: z
                      .string()
                      .describe(
                        'Id of the Staff Member who last performed check-in'
                      )
                      .regex(
                        /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                        'Must be a valid GUID'
                      )
                      .optional()
                      .nullable(),
                    checkInCanceledByStaffMember: z
                      .string()
                      .describe(
                        'Id of theStaff Member who last canceled check-in'
                      )
                      .regex(
                        /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                        'Must be a valid GUID'
                      )
                      .optional()
                      .nullable(),
                  })
                  .describe('Check-in details.')
                  .optional(),
                guestId: z
                  .number()
                  .int()
                  .describe('Guest ID.')
                  .min(1)
                  .optional()
                  .nullable(),
              })
            )
            .max(11)
            .optional(),
        })
        .describe('Guest list.')
        .optional(),
      language: z
        .string()
        .describe(
          '2-letter language code in the [ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes) format.'
        )
        .optional()
        .nullable(),
      locale: z
        .string()
        .describe(
          'Locale in the [IETF BCP 47](https://en.wikipedia.org/wiki/IETF_language_tag) format.'
        )
        .optional()
        .nullable(),
      fullyCheckedIn: z
        .boolean()
        .describe('Whether all guests are checked in.')
        .optional()
        .nullable(),
      checkedInGuestCount: z
        .number()
        .int()
        .describe('Number of checked in guests.')
        .optional()
        .nullable(),
      additionalGuestDetails: z
        .object({
          guestCount: z
            .number()
            .int()
            .describe('Number of additional guests.')
            .min(0)
            .max(10)
            .optional()
            .nullable(),
          guestNames: z.array(z.string()).max(10).optional(),
        })
        .describe('Additional guest details.')
        .optional(),
      disableNotifications: z
        .boolean()
        .describe('Whether notifications are disabled.')
        .optional()
        .nullable(),
      onlineConferencingLogin: z
        .object({
          link: z
            .string()
            .describe('Link URL to the online conference.')
            .url()
            .optional(),
          password: z
            .string()
            .describe('Password for the online conference.')
            .optional()
            .nullable(),
        })
        .describe(
          'Guest login details for accessing the online conference event.'
        )
        .optional(),
      anonymized: z
        .boolean()
        .describe('Whether an RSVP is anonymized.')
        .optional()
        .nullable(),
      marketingConsent: z
        .boolean()
        .describe('Whether a guest agreed to marketing.')
        .optional()
        .nullable(),
      extendedFields: z
        .object({
          namespaces: z
            .record(z.string(), z.record(z.string(), z.any()))
            .describe(
              'Extended field data. Each key corresponds to the namespace of the app that created the extended fields.\nThe value of each key is structured according to the schema defined when the extended fields were configured.\n\nYou can only access fields for which you have the appropriate permissions.\n\nLearn more about [extended fields](https://dev.wix.com/docs/rest/articles/getting-started/extended-fields).'
            )
            .optional(),
        })
        .describe(
          "Custom field data for the RSVP object.\n\n**Note:** You must configure extended fields using schema plugin extensions in your app's dashboard before you can access the extended fields with API calls."
        )
        .optional(),
    })
    .describe('Updated RSVP.')
    .optional(),
});
export const CancelRsvpGuestsCheckInRequest = z.object({
  rsvpId: z
    .string()
    .describe('ID of the RSVP to cancel check-in for.')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    ),
  options: z
    .object({
      guestIds: z.array(z.number().int()).min(1).max(11).optional(),
      fields: z
        .array(z.enum(['DETAILS', 'FORM', 'CONTACT_DETAILS']))
        .max(3)
        .optional(),
    })
    .optional(),
});
export const CancelRsvpGuestsCheckInResponse = z.object({
  rsvp: z
    .object({
      _id: z
        .string()
        .describe('ID of the RSVP.')
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional()
        .nullable(),
      revision: z
        .string()
        .regex(/^-?\d+$/, 'Must be a valid Int64 string')
        .describe(
          'Revision number, which increments by 1 each time the RSVP is updated. To prevent conflicting changes, the existing `revision` must be used when updating the RSVP.'
        )
        .optional()
        .nullable(),
      eventId: z
        .string()
        .describe('Event ID to which the RSVP belongs.')
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional()
        .nullable(),
      _createdDate: z
        .date()
        .describe('Date and time the RSVP was created.')
        .optional()
        .nullable(),
      _updatedDate: z
        .date()
        .describe('Date and time the RSVP was updated.')
        .optional()
        .nullable(),
      memberId: z
        .string()
        .describe('Site member ID.')
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional()
        .nullable(),
      contactId: z
        .string()
        .describe(
          'Contact ID of a guest who filled in the RSVP form. See the Contacts API for more details.'
        )
        .regex(
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
          'Must be a valid GUID'
        )
        .optional()
        .nullable(),
      firstName: z
        .string()
        .describe('First name of a guest who filled in the RSVP form.')
        .min(1)
        .max(50)
        .optional()
        .nullable(),
      lastName: z
        .string()
        .describe('Last name of a guest who filled in the RSVP form.')
        .min(1)
        .max(50)
        .optional()
        .nullable(),
      email: z
        .string()
        .describe('Email of a guest who filled in the RSVP form.')
        .email()
        .min(4)
        .max(255)
        .optional()
        .nullable(),
      form: z
        .object({
          inputValues: z
            .array(
              z.object({
                inputName: z
                  .string()
                  .describe('Form field input name.')
                  .max(100)
                  .optional(),
                value: z
                  .string()
                  .describe('Form field value.')
                  .max(5000)
                  .optional(),
                values: z.array(z.string()).max(100).optional(),
              })
            )
            .max(200)
            .optional(),
        })
        .describe('Event registration form.')
        .optional(),
      status: z
        .enum(['YES', 'NO', 'WAITLIST'])
        .describe('RSVP response status.')
        .optional(),
      totalGuests: z
        .number()
        .int()
        .describe('Total number of guests per 1 RSVP.')
        .optional()
        .nullable(),
      guestList: z
        .object({
          guests: z
            .array(
              z.object({
                index: z
                  .number()
                  .int()
                  .describe('Index of each guest in the array.')
                  .optional()
                  .nullable(),
                fullName: z
                  .string()
                  .describe('Full name.')
                  .max(101)
                  .optional()
                  .nullable(),
                checkInDetails: z
                  .object({
                    checkedIn: z
                      .boolean()
                      .describe('Whether the guest has checked in.')
                      .optional()
                      .nullable(),
                    checkInDate: z
                      .date()
                      .describe('Date and time the guest checked in.')
                      .optional()
                      .nullable(),
                    checkInCanceledDate: z
                      .date()
                      .describe('Date and time the guest cancelled check-in.')
                      .optional()
                      .nullable(),
                    checkedInBy: z
                      .string()
                      .describe('Id of the user who last performed check-in')
                      .regex(
                        /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                        'Must be a valid GUID'
                      )
                      .optional()
                      .nullable(),
                    checkInCanceledBy: z
                      .string()
                      .describe('Id of the user who last canceled check-in')
                      .regex(
                        /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                        'Must be a valid GUID'
                      )
                      .optional()
                      .nullable(),
                    checkedInByStaffMember: z
                      .string()
                      .describe(
                        'Id of the Staff Member who last performed check-in'
                      )
                      .regex(
                        /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                        'Must be a valid GUID'
                      )
                      .optional()
                      .nullable(),
                    checkInCanceledByStaffMember: z
                      .string()
                      .describe(
                        'Id of theStaff Member who last canceled check-in'
                      )
                      .regex(
                        /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                        'Must be a valid GUID'
                      )
                      .optional()
                      .nullable(),
                  })
                  .describe('Check-in details.')
                  .optional(),
                guestId: z
                  .number()
                  .int()
                  .describe('Guest ID.')
                  .min(1)
                  .optional()
                  .nullable(),
              })
            )
            .max(11)
            .optional(),
        })
        .describe('Guest list.')
        .optional(),
      language: z
        .string()
        .describe(
          '2-letter language code in the [ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes) format.'
        )
        .optional()
        .nullable(),
      locale: z
        .string()
        .describe(
          'Locale in the [IETF BCP 47](https://en.wikipedia.org/wiki/IETF_language_tag) format.'
        )
        .optional()
        .nullable(),
      fullyCheckedIn: z
        .boolean()
        .describe('Whether all guests are checked in.')
        .optional()
        .nullable(),
      checkedInGuestCount: z
        .number()
        .int()
        .describe('Number of checked in guests.')
        .optional()
        .nullable(),
      additionalGuestDetails: z
        .object({
          guestCount: z
            .number()
            .int()
            .describe('Number of additional guests.')
            .min(0)
            .max(10)
            .optional()
            .nullable(),
          guestNames: z.array(z.string()).max(10).optional(),
        })
        .describe('Additional guest details.')
        .optional(),
      disableNotifications: z
        .boolean()
        .describe('Whether notifications are disabled.')
        .optional()
        .nullable(),
      onlineConferencingLogin: z
        .object({
          link: z
            .string()
            .describe('Link URL to the online conference.')
            .url()
            .optional(),
          password: z
            .string()
            .describe('Password for the online conference.')
            .optional()
            .nullable(),
        })
        .describe(
          'Guest login details for accessing the online conference event.'
        )
        .optional(),
      anonymized: z
        .boolean()
        .describe('Whether an RSVP is anonymized.')
        .optional()
        .nullable(),
      marketingConsent: z
        .boolean()
        .describe('Whether a guest agreed to marketing.')
        .optional()
        .nullable(),
      extendedFields: z
        .object({
          namespaces: z
            .record(z.string(), z.record(z.string(), z.any()))
            .describe(
              'Extended field data. Each key corresponds to the namespace of the app that created the extended fields.\nThe value of each key is structured according to the schema defined when the extended fields were configured.\n\nYou can only access fields for which you have the appropriate permissions.\n\nLearn more about [extended fields](https://dev.wix.com/docs/rest/articles/getting-started/extended-fields).'
            )
            .optional(),
        })
        .describe(
          "Custom field data for the RSVP object.\n\n**Note:** You must configure extended fields using schema plugin extensions in your app's dashboard before you can access the extended fields with API calls."
        )
        .optional(),
    })
    .describe('Updated RSVP.')
    .optional(),
});
export const ListRsvpSummaryRequest = z.object({
  eventId: z.array(z.string()).min(1).max(100),
});
export const ListRsvpSummaryResponse = z.object({
  summaries: z
    .array(
      z.object({
        eventId: z
          .string()
          .describe('Event ID.')
          .regex(
            /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
            'Must be a valid GUID'
          )
          .optional()
          .nullable(),
        yesGuestCount: z
          .number()
          .int()
          .describe('Number of RSVPs that answered `yes`.')
          .optional()
          .nullable(),
        noGuestCount: z
          .number()
          .int()
          .describe('Number of RSVPs that answered `no`.')
          .optional()
          .nullable(),
        waitlistGuestCount: z
          .number()
          .int()
          .describe('Number of RSVPs that are in the waitlist.')
          .optional()
          .nullable(),
        totalRsvpCount: z
          .number()
          .int()
          .describe('Total number of RSVPs.')
          .optional()
          .nullable(),
      })
    )
    .optional(),
});
export const ListCurrentRsvpsRequest = z.object({
  eventId: z.array(z.string()).min(1).max(25),
  options: z
    .object({
      fields: z
        .array(z.enum(['DETAILS', 'FORM', 'CONTACT_DETAILS']))
        .max(3)
        .optional(),
      paging: z
        .object({
          limit: z
            .number()
            .int()
            .describe('Maximum number of items to return in the results.')
            .min(0)
            .max(100)
            .optional()
            .nullable(),
          cursor: z
            .string()
            .describe(
              "Pointer to the next or previous page in the list of results.\n\nPass the relevant cursor token from the `pagingMetadata` object in the previous call's response.\nNot relevant for the first request."
            )
            .max(16000)
            .optional()
            .nullable(),
        })
        .describe('Paging options.')
        .optional(),
    })
    .optional(),
});
export const ListCurrentRsvpsResponse = z.object({
  rsvps: z
    .array(
      z.object({
        _id: z
          .string()
          .describe('ID of the RSVP.')
          .regex(
            /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
            'Must be a valid GUID'
          )
          .optional()
          .nullable(),
        revision: z
          .string()
          .regex(/^-?\d+$/, 'Must be a valid Int64 string')
          .describe(
            'Revision number, which increments by 1 each time the RSVP is updated. To prevent conflicting changes, the existing `revision` must be used when updating the RSVP.'
          )
          .optional()
          .nullable(),
        eventId: z
          .string()
          .describe('Event ID to which the RSVP belongs.')
          .regex(
            /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
            'Must be a valid GUID'
          )
          .optional()
          .nullable(),
        _createdDate: z
          .date()
          .describe('Date and time the RSVP was created.')
          .optional()
          .nullable(),
        _updatedDate: z
          .date()
          .describe('Date and time the RSVP was updated.')
          .optional()
          .nullable(),
        memberId: z
          .string()
          .describe('Site member ID.')
          .regex(
            /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
            'Must be a valid GUID'
          )
          .optional()
          .nullable(),
        contactId: z
          .string()
          .describe(
            'Contact ID of a guest who filled in the RSVP form. See the Contacts API for more details.'
          )
          .regex(
            /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
            'Must be a valid GUID'
          )
          .optional()
          .nullable(),
        firstName: z
          .string()
          .describe('First name of a guest who filled in the RSVP form.')
          .min(1)
          .max(50)
          .optional()
          .nullable(),
        lastName: z
          .string()
          .describe('Last name of a guest who filled in the RSVP form.')
          .min(1)
          .max(50)
          .optional()
          .nullable(),
        email: z
          .string()
          .describe('Email of a guest who filled in the RSVP form.')
          .email()
          .min(4)
          .max(255)
          .optional()
          .nullable(),
        form: z
          .object({
            inputValues: z
              .array(
                z.object({
                  inputName: z
                    .string()
                    .describe('Form field input name.')
                    .max(100)
                    .optional(),
                  value: z
                    .string()
                    .describe('Form field value.')
                    .max(5000)
                    .optional(),
                  values: z.array(z.string()).max(100).optional(),
                })
              )
              .max(200)
              .optional(),
          })
          .describe('Event registration form.')
          .optional(),
        status: z
          .enum(['YES', 'NO', 'WAITLIST'])
          .describe('RSVP response status.')
          .optional(),
        totalGuests: z
          .number()
          .int()
          .describe('Total number of guests per 1 RSVP.')
          .optional()
          .nullable(),
        guestList: z
          .object({
            guests: z
              .array(
                z.object({
                  index: z
                    .number()
                    .int()
                    .describe('Index of each guest in the array.')
                    .optional()
                    .nullable(),
                  fullName: z
                    .string()
                    .describe('Full name.')
                    .max(101)
                    .optional()
                    .nullable(),
                  checkInDetails: z
                    .object({
                      checkedIn: z
                        .boolean()
                        .describe('Whether the guest has checked in.')
                        .optional()
                        .nullable(),
                      checkInDate: z
                        .date()
                        .describe('Date and time the guest checked in.')
                        .optional()
                        .nullable(),
                      checkInCanceledDate: z
                        .date()
                        .describe('Date and time the guest cancelled check-in.')
                        .optional()
                        .nullable(),
                      checkedInBy: z
                        .string()
                        .describe('Id of the user who last performed check-in')
                        .regex(
                          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                          'Must be a valid GUID'
                        )
                        .optional()
                        .nullable(),
                      checkInCanceledBy: z
                        .string()
                        .describe('Id of the user who last canceled check-in')
                        .regex(
                          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                          'Must be a valid GUID'
                        )
                        .optional()
                        .nullable(),
                      checkedInByStaffMember: z
                        .string()
                        .describe(
                          'Id of the Staff Member who last performed check-in'
                        )
                        .regex(
                          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                          'Must be a valid GUID'
                        )
                        .optional()
                        .nullable(),
                      checkInCanceledByStaffMember: z
                        .string()
                        .describe(
                          'Id of theStaff Member who last canceled check-in'
                        )
                        .regex(
                          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
                          'Must be a valid GUID'
                        )
                        .optional()
                        .nullable(),
                    })
                    .describe('Check-in details.')
                    .optional(),
                  guestId: z
                    .number()
                    .int()
                    .describe('Guest ID.')
                    .min(1)
                    .optional()
                    .nullable(),
                })
              )
              .max(11)
              .optional(),
          })
          .describe('Guest list.')
          .optional(),
        language: z
          .string()
          .describe(
            '2-letter language code in the [ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes) format.'
          )
          .optional()
          .nullable(),
        locale: z
          .string()
          .describe(
            'Locale in the [IETF BCP 47](https://en.wikipedia.org/wiki/IETF_language_tag) format.'
          )
          .optional()
          .nullable(),
        fullyCheckedIn: z
          .boolean()
          .describe('Whether all guests are checked in.')
          .optional()
          .nullable(),
        checkedInGuestCount: z
          .number()
          .int()
          .describe('Number of checked in guests.')
          .optional()
          .nullable(),
        additionalGuestDetails: z
          .object({
            guestCount: z
              .number()
              .int()
              .describe('Number of additional guests.')
              .min(0)
              .max(10)
              .optional()
              .nullable(),
            guestNames: z.array(z.string()).max(10).optional(),
          })
          .describe('Additional guest details.')
          .optional(),
        disableNotifications: z
          .boolean()
          .describe('Whether notifications are disabled.')
          .optional()
          .nullable(),
        onlineConferencingLogin: z
          .object({
            link: z
              .string()
              .describe('Link URL to the online conference.')
              .url()
              .optional(),
            password: z
              .string()
              .describe('Password for the online conference.')
              .optional()
              .nullable(),
          })
          .describe(
            'Guest login details for accessing the online conference event.'
          )
          .optional(),
        anonymized: z
          .boolean()
          .describe('Whether an RSVP is anonymized.')
          .optional()
          .nullable(),
        marketingConsent: z
          .boolean()
          .describe('Whether a guest agreed to marketing.')
          .optional()
          .nullable(),
        extendedFields: z
          .object({
            namespaces: z
              .record(z.string(), z.record(z.string(), z.any()))
              .describe(
                'Extended field data. Each key corresponds to the namespace of the app that created the extended fields.\nThe value of each key is structured according to the schema defined when the extended fields were configured.\n\nYou can only access fields for which you have the appropriate permissions.\n\nLearn more about [extended fields](https://dev.wix.com/docs/rest/articles/getting-started/extended-fields).'
              )
              .optional(),
          })
          .describe(
            "Custom field data for the RSVP object.\n\n**Note:** You must configure extended fields using schema plugin extensions in your app's dashboard before you can access the extended fields with API calls."
          )
          .optional(),
      })
    )
    .optional(),
  pagingMetadata: z
    .object({
      count: z
        .number()
        .int()
        .describe('Number of items returned in the response.')
        .optional()
        .nullable(),
      cursors: z
        .object({
          next: z
            .string()
            .describe(
              'Cursor string pointing to the next page in the list of results.'
            )
            .max(16000)
            .optional()
            .nullable(),
          prev: z
            .string()
            .describe(
              'Cursor pointing to the previous page in the list of results.'
            )
            .max(16000)
            .optional()
            .nullable(),
        })
        .describe(
          'Cursor strings that point to the next page, previous page, or both.'
        )
        .optional(),
      hasNext: z
        .boolean()
        .describe(
          'Whether there are more pages to retrieve following the current page.\n\n+ `true`: Another page of results can be retrieved.\n+ `false`: This is the last page.'
        )
        .optional()
        .nullable(),
    })
    .describe('Metadata for the paginated results.')
    .optional(),
});
